// prettier-ignore
export default {
  OpenapiGetV1CreditNotesPreviewInput: [
    'lines.tax_amounts',
    'lines.tax_rates',
  ],
  OpenapiGetV1CreditNotesPreviewInputLines: [
    'tax_amounts',
    'tax_rates',
  ],
  OpenapiGetV1CreditNotesPreviewInputLinesTaxAmountsMaybeEmpty: [],
  OpenapiGetV1CreditNotesPreviewInputLinesTaxRatesMaybeEmpty: [],
  OpenapiGetV1CreditNotesPreviewLinesInput: [
    'lines.tax_amounts',
    'lines.tax_rates',
  ],
  OpenapiGetV1CreditNotesPreviewLinesInputLines: [
    'tax_amounts',
    'tax_rates',
  ],
  OpenapiGetV1CreditNotesPreviewLinesInputLinesTaxAmountsMaybeEmpty: [],
  OpenapiGetV1CreditNotesPreviewLinesInputLinesTaxRatesMaybeEmpty: [],
  OpenapiGetV1InternalRubyReadFirstInput: [
    'array_param',
    'boolean_param',
    'float_param',
    'integer_param',
    'map_param',
  ],
  OpenapiGetV1InternalRubyReadFirstInputArrayParamMaybeEmpty: [],
  OpenapiGetV1InternalRubyReadFirstInputBooleanParamMaybeEmpty: [],
  OpenapiGetV1InternalRubyReadFirstInputFloatParamMaybeEmpty: [],
  OpenapiGetV1InternalRubyReadFirstInputIntegerParamMaybeEmpty: [],
  OpenapiGetV1InternalRubyReadFirstInputMapParamMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInput: [
    'customer_details.address',
    'customer_details.shipping',
    'discounts',
    'invoice_items.discounts',
    'invoice_items.metadata',
    'invoice_items.tax_rates',
    'schedule_details.amendments.metadata_actions.set',
    'schedule_details.billing_schedules',
    'schedule_details.phases.add_invoice_items.tax_rates',
    'schedule_details.phases.billing_thresholds',
    'schedule_details.phases.default_tax_rates',
    'schedule_details.phases.discounts',
    'schedule_details.phases.invoice_settings.account_tax_ids',
    'schedule_details.phases.invoice_settings.custom_fields',
    'schedule_details.phases.items.billing_thresholds',
    'schedule_details.phases.items.discounts',
    'schedule_details.phases.items.tax_rates',
    'schedule_details.phases.payment_settings.payment_method_options.acss_debit',
    'schedule_details.phases.payment_settings.payment_method_options.bancontact',
    'schedule_details.phases.payment_settings.payment_method_options.card',
    'schedule_details.phases.payment_settings.payment_method_options.card.mit_exemption',
    'schedule_details.phases.payment_settings.payment_method_options.customer_balance',
    'schedule_details.phases.payment_settings.payment_method_options.id_bank_transfer',
    'schedule_details.phases.payment_settings.payment_method_options.konbini',
    'schedule_details.phases.payment_settings.payment_method_options.payto',
    'schedule_details.phases.payment_settings.payment_method_options.pix',
    'schedule_details.phases.payment_settings.payment_method_options.sepa_debit',
    'schedule_details.phases.payment_settings.payment_method_options.upi',
    'schedule_details.phases.payment_settings.payment_method_options.us_bank_account',
    'schedule_details.phases.payment_settings.payment_method_types',
    'schedule_details.prebilling',
    'subscription_details.billing_schedules',
    'subscription_details.default_tax_rates',
    'subscription_details.items.billing_thresholds',
    'subscription_details.items.discounts',
    'subscription_details.items.metadata',
    'subscription_details.items.tax_rates',
  ],
  OpenapiGetV1InvoicesPreviewInputCustomerDetails: [
    'address',
    'shipping',
  ],
  OpenapiGetV1InvoicesPreviewInputCustomerDetailsAddressMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputCustomerDetailsShippingMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputInvoiceItems: [
    'discounts',
    'metadata',
    'tax_rates',
  ],
  OpenapiGetV1InvoicesPreviewInputInvoiceItemsDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputInvoiceItemsMetadataMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputInvoiceItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetails: [
    'amendments.metadata_actions.set',
    'billing_schedules',
    'phases.add_invoice_items.tax_rates',
    'phases.billing_thresholds',
    'phases.default_tax_rates',
    'phases.discounts',
    'phases.invoice_settings.account_tax_ids',
    'phases.invoice_settings.custom_fields',
    'phases.items.billing_thresholds',
    'phases.items.discounts',
    'phases.items.tax_rates',
    'phases.payment_settings.payment_method_options.acss_debit',
    'phases.payment_settings.payment_method_options.bancontact',
    'phases.payment_settings.payment_method_options.card',
    'phases.payment_settings.payment_method_options.card.mit_exemption',
    'phases.payment_settings.payment_method_options.customer_balance',
    'phases.payment_settings.payment_method_options.id_bank_transfer',
    'phases.payment_settings.payment_method_options.konbini',
    'phases.payment_settings.payment_method_options.payto',
    'phases.payment_settings.payment_method_options.pix',
    'phases.payment_settings.payment_method_options.sepa_debit',
    'phases.payment_settings.payment_method_options.upi',
    'phases.payment_settings.payment_method_options.us_bank_account',
    'phases.payment_settings.payment_method_types',
    'prebilling',
  ],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsAmendments: [
    'metadata_actions.set',
  ],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsAmendmentsMetadataActions: [
    'set',
  ],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsAmendmentsMetadataActionsSetMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsBillingSchedulesMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhases: [
    'add_invoice_items.tax_rates',
    'billing_thresholds',
    'default_tax_rates',
    'discounts',
    'invoice_settings.account_tax_ids',
    'invoice_settings.custom_fields',
    'items.billing_thresholds',
    'items.discounts',
    'items.tax_rates',
    'payment_settings.payment_method_options.acss_debit',
    'payment_settings.payment_method_options.bancontact',
    'payment_settings.payment_method_options.card',
    'payment_settings.payment_method_options.card.mit_exemption',
    'payment_settings.payment_method_options.customer_balance',
    'payment_settings.payment_method_options.id_bank_transfer',
    'payment_settings.payment_method_options.konbini',
    'payment_settings.payment_method_options.payto',
    'payment_settings.payment_method_options.pix',
    'payment_settings.payment_method_options.sepa_debit',
    'payment_settings.payment_method_options.upi',
    'payment_settings.payment_method_options.us_bank_account',
    'payment_settings.payment_method_types',
  ],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesAddInvoiceItems: [
    'tax_rates',
  ],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesAddInvoiceItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesBillingThresholdsMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesDefaultTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesInvoiceSettings: [
    'account_tax_ids',
    'custom_fields',
  ],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesInvoiceSettingsAccountTaxIdsMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesItems: [
    'billing_thresholds',
    'discounts',
    'tax_rates',
  ],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesItemsBillingThresholdsMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesItemsDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettings: [
    'payment_method_options.acss_debit',
    'payment_method_options.bancontact',
    'payment_method_options.card',
    'payment_method_options.card.mit_exemption',
    'payment_method_options.customer_balance',
    'payment_method_options.id_bank_transfer',
    'payment_method_options.konbini',
    'payment_method_options.payto',
    'payment_method_options.pix',
    'payment_method_options.sepa_debit',
    'payment_method_options.upi',
    'payment_method_options.us_bank_account',
    'payment_method_types',
  ],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptions: [
    'acss_debit',
    'bancontact',
    'card',
    'card.mit_exemption',
    'customer_balance',
    'id_bank_transfer',
    'konbini',
    'payto',
    'pix',
    'sepa_debit',
    'upi',
    'us_bank_account',
  ],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsAcssDebitMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsBancontactMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsCard: [
    'mit_exemption',
  ],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsCardMaybeEmpty: [
    'mit_exemption',
  ],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsCardMitExemptionMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsCustomerBalanceMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsIdBankTransferMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsKonbiniMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsPaytoMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsPixMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsSepaDebitMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsUpiMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPhasesPaymentSettingsPaymentMethodTypesMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputScheduleDetailsPrebillingMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputSubscriptionDetails: [
    'billing_schedules',
    'default_tax_rates',
    'items.billing_thresholds',
    'items.discounts',
    'items.metadata',
    'items.tax_rates',
  ],
  OpenapiGetV1InvoicesPreviewInputSubscriptionDetailsBillingSchedulesMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputSubscriptionDetailsDefaultTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputSubscriptionDetailsItems: [
    'billing_thresholds',
    'discounts',
    'metadata',
    'tax_rates',
  ],
  OpenapiGetV1InvoicesPreviewInputSubscriptionDetailsItemsBillingThresholdsMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputSubscriptionDetailsItemsDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputSubscriptionDetailsItemsMetadataMaybeEmpty: [],
  OpenapiGetV1InvoicesPreviewInputSubscriptionDetailsItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInput: [
    'customer_details.address',
    'customer_details.shipping',
    'discounts',
    'invoice_items.discounts',
    'invoice_items.metadata',
    'invoice_items.tax_rates',
    'schedule_details.amendments.metadata_actions.set',
    'schedule_details.billing_schedules',
    'schedule_details.phases.add_invoice_items.tax_rates',
    'schedule_details.phases.billing_thresholds',
    'schedule_details.phases.default_tax_rates',
    'schedule_details.phases.discounts',
    'schedule_details.phases.invoice_settings.account_tax_ids',
    'schedule_details.phases.invoice_settings.custom_fields',
    'schedule_details.phases.items.billing_thresholds',
    'schedule_details.phases.items.discounts',
    'schedule_details.phases.items.tax_rates',
    'schedule_details.phases.payment_settings.payment_method_options.acss_debit',
    'schedule_details.phases.payment_settings.payment_method_options.bancontact',
    'schedule_details.phases.payment_settings.payment_method_options.card',
    'schedule_details.phases.payment_settings.payment_method_options.card.mit_exemption',
    'schedule_details.phases.payment_settings.payment_method_options.customer_balance',
    'schedule_details.phases.payment_settings.payment_method_options.id_bank_transfer',
    'schedule_details.phases.payment_settings.payment_method_options.konbini',
    'schedule_details.phases.payment_settings.payment_method_options.payto',
    'schedule_details.phases.payment_settings.payment_method_options.pix',
    'schedule_details.phases.payment_settings.payment_method_options.sepa_debit',
    'schedule_details.phases.payment_settings.payment_method_options.upi',
    'schedule_details.phases.payment_settings.payment_method_options.us_bank_account',
    'schedule_details.phases.payment_settings.payment_method_types',
    'schedule_details.prebilling',
    'subscription_cancel_at',
    'subscription_default_tax_rates',
    'subscription_details.billing_schedules',
    'subscription_details.default_tax_rates',
    'subscription_details.items.billing_thresholds',
    'subscription_details.items.discounts',
    'subscription_details.items.metadata',
    'subscription_details.items.tax_rates',
    'subscription_items.billing_thresholds',
    'subscription_items.discounts',
    'subscription_items.metadata',
    'subscription_items.tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingInputCustomerDetails: [
    'address',
    'shipping',
  ],
  OpenapiGetV1InvoicesUpcomingInputCustomerDetailsAddressMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputCustomerDetailsShippingMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputInvoiceItems: [
    'discounts',
    'metadata',
    'tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingInputInvoiceItemsDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputInvoiceItemsMetadataMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputInvoiceItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetails: [
    'amendments.metadata_actions.set',
    'billing_schedules',
    'phases.add_invoice_items.tax_rates',
    'phases.billing_thresholds',
    'phases.default_tax_rates',
    'phases.discounts',
    'phases.invoice_settings.account_tax_ids',
    'phases.invoice_settings.custom_fields',
    'phases.items.billing_thresholds',
    'phases.items.discounts',
    'phases.items.tax_rates',
    'phases.payment_settings.payment_method_options.acss_debit',
    'phases.payment_settings.payment_method_options.bancontact',
    'phases.payment_settings.payment_method_options.card',
    'phases.payment_settings.payment_method_options.card.mit_exemption',
    'phases.payment_settings.payment_method_options.customer_balance',
    'phases.payment_settings.payment_method_options.id_bank_transfer',
    'phases.payment_settings.payment_method_options.konbini',
    'phases.payment_settings.payment_method_options.payto',
    'phases.payment_settings.payment_method_options.pix',
    'phases.payment_settings.payment_method_options.sepa_debit',
    'phases.payment_settings.payment_method_options.upi',
    'phases.payment_settings.payment_method_options.us_bank_account',
    'phases.payment_settings.payment_method_types',
    'prebilling',
  ],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsAmendments: [
    'metadata_actions.set',
  ],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsAmendmentsMetadataActions: [
    'set',
  ],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsAmendmentsMetadataActionsSetMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsBillingSchedulesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhases: [
    'add_invoice_items.tax_rates',
    'billing_thresholds',
    'default_tax_rates',
    'discounts',
    'invoice_settings.account_tax_ids',
    'invoice_settings.custom_fields',
    'items.billing_thresholds',
    'items.discounts',
    'items.tax_rates',
    'payment_settings.payment_method_options.acss_debit',
    'payment_settings.payment_method_options.bancontact',
    'payment_settings.payment_method_options.card',
    'payment_settings.payment_method_options.card.mit_exemption',
    'payment_settings.payment_method_options.customer_balance',
    'payment_settings.payment_method_options.id_bank_transfer',
    'payment_settings.payment_method_options.konbini',
    'payment_settings.payment_method_options.payto',
    'payment_settings.payment_method_options.pix',
    'payment_settings.payment_method_options.sepa_debit',
    'payment_settings.payment_method_options.upi',
    'payment_settings.payment_method_options.us_bank_account',
    'payment_settings.payment_method_types',
  ],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesAddInvoiceItems: [
    'tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesAddInvoiceItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesBillingThresholdsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesDefaultTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesInvoiceSettings: [
    'account_tax_ids',
    'custom_fields',
  ],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesInvoiceSettingsAccountTaxIdsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesItems: [
    'billing_thresholds',
    'discounts',
    'tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesItemsBillingThresholdsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesItemsDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettings: [
    'payment_method_options.acss_debit',
    'payment_method_options.bancontact',
    'payment_method_options.card',
    'payment_method_options.card.mit_exemption',
    'payment_method_options.customer_balance',
    'payment_method_options.id_bank_transfer',
    'payment_method_options.konbini',
    'payment_method_options.payto',
    'payment_method_options.pix',
    'payment_method_options.sepa_debit',
    'payment_method_options.upi',
    'payment_method_options.us_bank_account',
    'payment_method_types',
  ],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptions: [
    'acss_debit',
    'bancontact',
    'card',
    'card.mit_exemption',
    'customer_balance',
    'id_bank_transfer',
    'konbini',
    'payto',
    'pix',
    'sepa_debit',
    'upi',
    'us_bank_account',
  ],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsAcssDebitMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsBancontactMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsCard: [
    'mit_exemption',
  ],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsCardMaybeEmpty: [
    'mit_exemption',
  ],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsCardMitExemptionMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsCustomerBalanceMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsIdBankTransferMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsKonbiniMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsPaytoMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsPixMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsSepaDebitMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsUpiMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPhasesPaymentSettingsPaymentMethodTypesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputScheduleDetailsPrebillingMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionCancelAtMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionDefaultTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionDetails: [
    'billing_schedules',
    'default_tax_rates',
    'items.billing_thresholds',
    'items.discounts',
    'items.metadata',
    'items.tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionDetailsBillingSchedulesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionDetailsDefaultTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionDetailsItems: [
    'billing_thresholds',
    'discounts',
    'metadata',
    'tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionDetailsItemsBillingThresholdsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionDetailsItemsDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionDetailsItemsMetadataMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionDetailsItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionItems: [
    'billing_thresholds',
    'discounts',
    'metadata',
    'tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionItemsBillingThresholdsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionItemsDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionItemsMetadataMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingInputSubscriptionItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInput: [
    'customer_details.address',
    'customer_details.shipping',
    'discounts',
    'invoice_items.discounts',
    'invoice_items.metadata',
    'invoice_items.tax_rates',
    'schedule_details.amendments.metadata_actions.set',
    'schedule_details.billing_schedules',
    'schedule_details.phases.add_invoice_items.tax_rates',
    'schedule_details.phases.billing_thresholds',
    'schedule_details.phases.default_tax_rates',
    'schedule_details.phases.discounts',
    'schedule_details.phases.invoice_settings.account_tax_ids',
    'schedule_details.phases.invoice_settings.custom_fields',
    'schedule_details.phases.items.billing_thresholds',
    'schedule_details.phases.items.discounts',
    'schedule_details.phases.items.tax_rates',
    'schedule_details.phases.payment_settings.payment_method_options.acss_debit',
    'schedule_details.phases.payment_settings.payment_method_options.bancontact',
    'schedule_details.phases.payment_settings.payment_method_options.card',
    'schedule_details.phases.payment_settings.payment_method_options.card.mit_exemption',
    'schedule_details.phases.payment_settings.payment_method_options.customer_balance',
    'schedule_details.phases.payment_settings.payment_method_options.id_bank_transfer',
    'schedule_details.phases.payment_settings.payment_method_options.konbini',
    'schedule_details.phases.payment_settings.payment_method_options.payto',
    'schedule_details.phases.payment_settings.payment_method_options.pix',
    'schedule_details.phases.payment_settings.payment_method_options.sepa_debit',
    'schedule_details.phases.payment_settings.payment_method_options.upi',
    'schedule_details.phases.payment_settings.payment_method_options.us_bank_account',
    'schedule_details.phases.payment_settings.payment_method_types',
    'schedule_details.prebilling',
    'subscription_cancel_at',
    'subscription_default_tax_rates',
    'subscription_details.billing_schedules',
    'subscription_details.default_tax_rates',
    'subscription_details.items.billing_thresholds',
    'subscription_details.items.discounts',
    'subscription_details.items.metadata',
    'subscription_details.items.tax_rates',
    'subscription_items.billing_thresholds',
    'subscription_items.discounts',
    'subscription_items.metadata',
    'subscription_items.tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputCustomerDetails: [
    'address',
    'shipping',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputCustomerDetailsAddressMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputCustomerDetailsShippingMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputInvoiceItems: [
    'discounts',
    'metadata',
    'tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputInvoiceItemsDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputInvoiceItemsMetadataMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputInvoiceItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetails: [
    'amendments.metadata_actions.set',
    'billing_schedules',
    'phases.add_invoice_items.tax_rates',
    'phases.billing_thresholds',
    'phases.default_tax_rates',
    'phases.discounts',
    'phases.invoice_settings.account_tax_ids',
    'phases.invoice_settings.custom_fields',
    'phases.items.billing_thresholds',
    'phases.items.discounts',
    'phases.items.tax_rates',
    'phases.payment_settings.payment_method_options.acss_debit',
    'phases.payment_settings.payment_method_options.bancontact',
    'phases.payment_settings.payment_method_options.card',
    'phases.payment_settings.payment_method_options.card.mit_exemption',
    'phases.payment_settings.payment_method_options.customer_balance',
    'phases.payment_settings.payment_method_options.id_bank_transfer',
    'phases.payment_settings.payment_method_options.konbini',
    'phases.payment_settings.payment_method_options.payto',
    'phases.payment_settings.payment_method_options.pix',
    'phases.payment_settings.payment_method_options.sepa_debit',
    'phases.payment_settings.payment_method_options.upi',
    'phases.payment_settings.payment_method_options.us_bank_account',
    'phases.payment_settings.payment_method_types',
    'prebilling',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsAmendments: [
    'metadata_actions.set',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsAmendmentsMetadataActions: [
    'set',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsAmendmentsMetadataActionsSetMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsBillingSchedulesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhases: [
    'add_invoice_items.tax_rates',
    'billing_thresholds',
    'default_tax_rates',
    'discounts',
    'invoice_settings.account_tax_ids',
    'invoice_settings.custom_fields',
    'items.billing_thresholds',
    'items.discounts',
    'items.tax_rates',
    'payment_settings.payment_method_options.acss_debit',
    'payment_settings.payment_method_options.bancontact',
    'payment_settings.payment_method_options.card',
    'payment_settings.payment_method_options.card.mit_exemption',
    'payment_settings.payment_method_options.customer_balance',
    'payment_settings.payment_method_options.id_bank_transfer',
    'payment_settings.payment_method_options.konbini',
    'payment_settings.payment_method_options.payto',
    'payment_settings.payment_method_options.pix',
    'payment_settings.payment_method_options.sepa_debit',
    'payment_settings.payment_method_options.upi',
    'payment_settings.payment_method_options.us_bank_account',
    'payment_settings.payment_method_types',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesAddInvoiceItems: [
    'tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesAddInvoiceItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesBillingThresholdsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesDefaultTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesInvoiceSettings: [
    'account_tax_ids',
    'custom_fields',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesInvoiceSettingsAccountTaxIdsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesItems: [
    'billing_thresholds',
    'discounts',
    'tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesItemsBillingThresholdsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesItemsDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettings: [
    'payment_method_options.acss_debit',
    'payment_method_options.bancontact',
    'payment_method_options.card',
    'payment_method_options.card.mit_exemption',
    'payment_method_options.customer_balance',
    'payment_method_options.id_bank_transfer',
    'payment_method_options.konbini',
    'payment_method_options.payto',
    'payment_method_options.pix',
    'payment_method_options.sepa_debit',
    'payment_method_options.upi',
    'payment_method_options.us_bank_account',
    'payment_method_types',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptions: [
    'acss_debit',
    'bancontact',
    'card',
    'card.mit_exemption',
    'customer_balance',
    'id_bank_transfer',
    'konbini',
    'payto',
    'pix',
    'sepa_debit',
    'upi',
    'us_bank_account',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsAcssDebitMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsBancontactMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsCard: [
    'mit_exemption',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsCardMaybeEmpty: [
    'mit_exemption',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsCardMitExemptionMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsCustomerBalanceMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsIdBankTransferMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsKonbiniMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsPaytoMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsPixMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsSepaDebitMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsUpiMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPhasesPaymentSettingsPaymentMethodTypesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputScheduleDetailsPrebillingMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionCancelAtMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionDefaultTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionDetails: [
    'billing_schedules',
    'default_tax_rates',
    'items.billing_thresholds',
    'items.discounts',
    'items.metadata',
    'items.tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionDetailsBillingSchedulesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionDetailsDefaultTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionDetailsItems: [
    'billing_thresholds',
    'discounts',
    'metadata',
    'tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionDetailsItemsBillingThresholdsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionDetailsItemsDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionDetailsItemsMetadataMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionDetailsItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionItems: [
    'billing_thresholds',
    'discounts',
    'metadata',
    'tax_rates',
  ],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionItemsBillingThresholdsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionItemsDiscountsMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionItemsMetadataMaybeEmpty: [],
  OpenapiGetV1InvoicesUpcomingLinesInputSubscriptionItemsTaxRatesMaybeEmpty: [],
  OpenapiGetV1TerminalLocationsInput: [
    'zones',
  ],
  OpenapiGetV1TerminalLocationsInputZonesMaybeEmpty: [],
  OpenapiPostV1AccountBatchPersonsInput: [
    'people.dob',
    'people.full_name_aliases',
    'people.metadata',
    'people.relationship.percent_ownership',
  ],
  OpenapiPostV1AccountBatchPersonsInputPeople: [
    'dob',
    'full_name_aliases',
    'metadata',
    'relationship.percent_ownership',
  ],
  OpenapiPostV1AccountBatchPersonsInputPeopleDobMaybeEmpty: [],
  OpenapiPostV1AccountBatchPersonsInputPeopleFullNameAliasesMaybeEmpty: [],
  OpenapiPostV1AccountBatchPersonsInputPeopleMetadataMaybeEmpty: [],
  OpenapiPostV1AccountBatchPersonsInputPeopleRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1AccountBatchPersonsInputPeopleRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountInput: [
    'company.registration_date',
    'individual.dob',
    'individual.full_name_aliases',
    'individual.metadata',
    'individual.percent_ownership',
    'individual.personal_relationship.percent_ownership',
    'individual.relationship.percent_ownership',
    'invoice_settings.custom_fields',
    'invoice_settings.pause_collection_live',
    'invoice_settings.pause_collection_test',
    'invoice_settings.rendering_options',
    'metadata',
    'settings.atlas.percent_equity_pool',
    'settings.atlas.shares_distribution',
    'settings.atlas.shares_distribution.num_shares',
    'settings.atlas.total_number_of_shares',
    'settings.atlas.vesting_cliff',
    'settings.atlas.vesting_duration',
    'settings.atlas.vesting_start',
    'settings.invoices.default_account_tax_ids',
  ],
  OpenapiPostV1AccountInputCompany: [
    'registration_date',
  ],
  OpenapiPostV1AccountInputCompanyRegistrationDateMaybeEmpty: [],
  OpenapiPostV1AccountInputIndividual: [
    'dob',
    'full_name_aliases',
    'metadata',
    'percent_ownership',
    'personal_relationship.percent_ownership',
    'relationship.percent_ownership',
  ],
  OpenapiPostV1AccountInputIndividualDobMaybeEmpty: [],
  OpenapiPostV1AccountInputIndividualFullNameAliasesMaybeEmpty: [],
  OpenapiPostV1AccountInputIndividualMetadataMaybeEmpty: [],
  OpenapiPostV1AccountInputIndividualPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountInputIndividualPersonalRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1AccountInputIndividualPersonalRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountInputIndividualRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1AccountInputIndividualRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountInputInvoiceSettings: [
    'custom_fields',
    'pause_collection_live',
    'pause_collection_test',
    'rendering_options',
  ],
  OpenapiPostV1AccountInputInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1AccountInputInvoiceSettingsPauseCollectionLiveMaybeEmpty: [],
  OpenapiPostV1AccountInputInvoiceSettingsPauseCollectionTestMaybeEmpty: [],
  OpenapiPostV1AccountInputInvoiceSettingsRenderingOptionsMaybeEmpty: [],
  OpenapiPostV1AccountInputMetadataMaybeEmpty: [],
  OpenapiPostV1AccountInputSettings: [
    'atlas.percent_equity_pool',
    'atlas.shares_distribution',
    'atlas.shares_distribution.num_shares',
    'atlas.total_number_of_shares',
    'atlas.vesting_cliff',
    'atlas.vesting_duration',
    'atlas.vesting_start',
    'invoices.default_account_tax_ids',
  ],
  OpenapiPostV1AccountInputSettingsAtlas: [
    'percent_equity_pool',
    'shares_distribution',
    'shares_distribution.num_shares',
    'total_number_of_shares',
    'vesting_cliff',
    'vesting_duration',
    'vesting_start',
  ],
  OpenapiPostV1AccountInputSettingsAtlasPercentEquityPoolMaybeEmpty: [],
  OpenapiPostV1AccountInputSettingsAtlasSharesDistribution: [
    'num_shares',
  ],
  OpenapiPostV1AccountInputSettingsAtlasSharesDistributionMaybeEmpty: [
    'num_shares',
  ],
  OpenapiPostV1AccountInputSettingsAtlasSharesDistributionNumSharesMaybeEmpty: [],
  OpenapiPostV1AccountInputSettingsAtlasTotalNumberOfSharesMaybeEmpty: [],
  OpenapiPostV1AccountInputSettingsAtlasVestingCliffMaybeEmpty: [],
  OpenapiPostV1AccountInputSettingsAtlasVestingDurationMaybeEmpty: [],
  OpenapiPostV1AccountInputSettingsAtlasVestingStartMaybeEmpty: [],
  OpenapiPostV1AccountInputSettingsInvoices: [
    'default_account_tax_ids',
  ],
  OpenapiPostV1AccountInputSettingsInvoicesDefaultAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1AccountsAccountBatchPersonsInput: [
    'people.dob',
    'people.full_name_aliases',
    'people.metadata',
    'people.relationship.percent_ownership',
  ],
  OpenapiPostV1AccountsAccountBatchPersonsInputPeople: [
    'dob',
    'full_name_aliases',
    'metadata',
    'relationship.percent_ownership',
  ],
  OpenapiPostV1AccountsAccountBatchPersonsInputPeopleDobMaybeEmpty: [],
  OpenapiPostV1AccountsAccountBatchPersonsInputPeopleFullNameAliasesMaybeEmpty: [],
  OpenapiPostV1AccountsAccountBatchPersonsInputPeopleMetadataMaybeEmpty: [],
  OpenapiPostV1AccountsAccountBatchPersonsInputPeopleRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1AccountsAccountBatchPersonsInputPeopleRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountsAccountExternalAccountsIdInput: [
    'metadata',
  ],
  OpenapiPostV1AccountsAccountExternalAccountsIdInputMetadataMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInput: [
    'company.registration_date',
    'individual.dob',
    'individual.full_name_aliases',
    'individual.metadata',
    'individual.percent_ownership',
    'individual.personal_relationship.percent_ownership',
    'individual.relationship.percent_ownership',
    'invoice_settings.custom_fields',
    'invoice_settings.pause_collection_live',
    'invoice_settings.pause_collection_test',
    'invoice_settings.rendering_options',
    'metadata',
    'settings.atlas.percent_equity_pool',
    'settings.atlas.shares_distribution',
    'settings.atlas.shares_distribution.num_shares',
    'settings.atlas.total_number_of_shares',
    'settings.atlas.vesting_cliff',
    'settings.atlas.vesting_duration',
    'settings.atlas.vesting_start',
    'settings.invoices.default_account_tax_ids',
  ],
  OpenapiPostV1AccountsAccountInputCompany: [
    'registration_date',
  ],
  OpenapiPostV1AccountsAccountInputCompanyRegistrationDateMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputIndividual: [
    'dob',
    'full_name_aliases',
    'metadata',
    'percent_ownership',
    'personal_relationship.percent_ownership',
    'relationship.percent_ownership',
  ],
  OpenapiPostV1AccountsAccountInputIndividualDobMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputIndividualFullNameAliasesMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputIndividualMetadataMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputIndividualPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputIndividualPersonalRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1AccountsAccountInputIndividualPersonalRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputIndividualRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1AccountsAccountInputIndividualRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputInvoiceSettings: [
    'custom_fields',
    'pause_collection_live',
    'pause_collection_test',
    'rendering_options',
  ],
  OpenapiPostV1AccountsAccountInputInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputInvoiceSettingsPauseCollectionLiveMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputInvoiceSettingsPauseCollectionTestMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputInvoiceSettingsRenderingOptionsMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputMetadataMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputSettings: [
    'atlas.percent_equity_pool',
    'atlas.shares_distribution',
    'atlas.shares_distribution.num_shares',
    'atlas.total_number_of_shares',
    'atlas.vesting_cliff',
    'atlas.vesting_duration',
    'atlas.vesting_start',
    'invoices.default_account_tax_ids',
  ],
  OpenapiPostV1AccountsAccountInputSettingsAtlas: [
    'percent_equity_pool',
    'shares_distribution',
    'shares_distribution.num_shares',
    'total_number_of_shares',
    'vesting_cliff',
    'vesting_duration',
    'vesting_start',
  ],
  OpenapiPostV1AccountsAccountInputSettingsAtlasPercentEquityPoolMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputSettingsAtlasSharesDistribution: [
    'num_shares',
  ],
  OpenapiPostV1AccountsAccountInputSettingsAtlasSharesDistributionMaybeEmpty: [
    'num_shares',
  ],
  OpenapiPostV1AccountsAccountInputSettingsAtlasSharesDistributionNumSharesMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputSettingsAtlasTotalNumberOfSharesMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputSettingsAtlasVestingCliffMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputSettingsAtlasVestingDurationMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputSettingsAtlasVestingStartMaybeEmpty: [],
  OpenapiPostV1AccountsAccountInputSettingsInvoices: [
    'default_account_tax_ids',
  ],
  OpenapiPostV1AccountsAccountInputSettingsInvoicesDefaultAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1AccountsAccountPersonsInput: [
    'dob',
    'full_name_aliases',
    'metadata',
    'relationship.percent_ownership',
  ],
  OpenapiPostV1AccountsAccountPersonsInputDobMaybeEmpty: [],
  OpenapiPostV1AccountsAccountPersonsInputFullNameAliasesMaybeEmpty: [],
  OpenapiPostV1AccountsAccountPersonsInputMetadataMaybeEmpty: [],
  OpenapiPostV1AccountsAccountPersonsInputRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1AccountsAccountPersonsInputRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountsAccountPersonsPersonInput: [
    'dob',
    'full_name_aliases',
    'metadata',
    'relationship.percent_ownership',
  ],
  OpenapiPostV1AccountsAccountPersonsPersonInputDobMaybeEmpty: [],
  OpenapiPostV1AccountsAccountPersonsPersonInputFullNameAliasesMaybeEmpty: [],
  OpenapiPostV1AccountsAccountPersonsPersonInputMetadataMaybeEmpty: [],
  OpenapiPostV1AccountsAccountPersonsPersonInputRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1AccountsAccountPersonsPersonInputRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountsInput: [
    'company.registration_date',
    'individual.dob',
    'individual.full_name_aliases',
    'individual.metadata',
    'individual.percent_ownership',
    'individual.personal_relationship.percent_ownership',
    'individual.relationship.percent_ownership',
    'invoice_settings.custom_fields',
    'invoice_settings.pause_collection_live',
    'invoice_settings.pause_collection_test',
    'invoice_settings.rendering_options',
    'metadata',
    'settings.atlas.percent_equity_pool',
    'settings.atlas.shares_distribution',
    'settings.atlas.shares_distribution.num_shares',
    'settings.atlas.total_number_of_shares',
    'settings.atlas.vesting_cliff',
    'settings.atlas.vesting_duration',
    'settings.atlas.vesting_start',
  ],
  OpenapiPostV1AccountsInputCompany: [
    'registration_date',
  ],
  OpenapiPostV1AccountsInputCompanyRegistrationDateMaybeEmpty: [],
  OpenapiPostV1AccountsInputIndividual: [
    'dob',
    'full_name_aliases',
    'metadata',
    'percent_ownership',
    'personal_relationship.percent_ownership',
    'relationship.percent_ownership',
  ],
  OpenapiPostV1AccountsInputIndividualDobMaybeEmpty: [],
  OpenapiPostV1AccountsInputIndividualFullNameAliasesMaybeEmpty: [],
  OpenapiPostV1AccountsInputIndividualMetadataMaybeEmpty: [],
  OpenapiPostV1AccountsInputIndividualPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountsInputIndividualPersonalRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1AccountsInputIndividualPersonalRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountsInputIndividualRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1AccountsInputIndividualRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1AccountsInputInvoiceSettings: [
    'custom_fields',
    'pause_collection_live',
    'pause_collection_test',
    'rendering_options',
  ],
  OpenapiPostV1AccountsInputInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1AccountsInputInvoiceSettingsPauseCollectionLiveMaybeEmpty: [],
  OpenapiPostV1AccountsInputInvoiceSettingsPauseCollectionTestMaybeEmpty: [],
  OpenapiPostV1AccountsInputInvoiceSettingsRenderingOptionsMaybeEmpty: [],
  OpenapiPostV1AccountsInputMetadataMaybeEmpty: [],
  OpenapiPostV1AccountsInputSettings: [
    'atlas.percent_equity_pool',
    'atlas.shares_distribution',
    'atlas.shares_distribution.num_shares',
    'atlas.total_number_of_shares',
    'atlas.vesting_cliff',
    'atlas.vesting_duration',
    'atlas.vesting_start',
  ],
  OpenapiPostV1AccountsInputSettingsAtlas: [
    'percent_equity_pool',
    'shares_distribution',
    'shares_distribution.num_shares',
    'total_number_of_shares',
    'vesting_cliff',
    'vesting_duration',
    'vesting_start',
  ],
  OpenapiPostV1AccountsInputSettingsAtlasPercentEquityPoolMaybeEmpty: [],
  OpenapiPostV1AccountsInputSettingsAtlasSharesDistribution: [
    'num_shares',
  ],
  OpenapiPostV1AccountsInputSettingsAtlasSharesDistributionMaybeEmpty: [
    'num_shares',
  ],
  OpenapiPostV1AccountsInputSettingsAtlasSharesDistributionNumSharesMaybeEmpty: [],
  OpenapiPostV1AccountsInputSettingsAtlasTotalNumberOfSharesMaybeEmpty: [],
  OpenapiPostV1AccountsInputSettingsAtlasVestingCliffMaybeEmpty: [],
  OpenapiPostV1AccountsInputSettingsAtlasVestingDurationMaybeEmpty: [],
  OpenapiPostV1AccountsInputSettingsAtlasVestingStartMaybeEmpty: [],
  OpenapiPostV1AgenticCommerceSellerConfigInput: [
    'checkout_adapter_config.application_fee_hook_enabled',
    'checkout_adapter_config.manual_approval_hook_enabled',
    'checkout_adapter_config.shipping_hook_enabled',
    'checkout_adapter_config.tax_hook_enabled',
    'return_window',
  ],
  OpenapiPostV1AgenticCommerceSellerConfigInputCheckoutAdapterConfig: [
    'application_fee_hook_enabled',
    'manual_approval_hook_enabled',
    'shipping_hook_enabled',
    'tax_hook_enabled',
  ],
  OpenapiPostV1AgenticCommerceSellerConfigInputCheckoutAdapterConfigApplicationFeeHookEnabledMaybeEmpty: [],
  OpenapiPostV1AgenticCommerceSellerConfigInputCheckoutAdapterConfigManualApprovalHookEnabledMaybeEmpty: [],
  OpenapiPostV1AgenticCommerceSellerConfigInputCheckoutAdapterConfigShippingHookEnabledMaybeEmpty: [],
  OpenapiPostV1AgenticCommerceSellerConfigInputCheckoutAdapterConfigTaxHookEnabledMaybeEmpty: [],
  OpenapiPostV1AgenticCommerceSellerConfigInputReturnWindowMaybeEmpty: [],
  OpenapiPostV1BalanceSettingsInput: [
    'payments.payouts.automatic_transfer_rules_by_currency',
    'payments.payouts.default_payout_method_for_currency',
    'payments.payouts.minimum_balance_by_currency',
    'payments.settlement_timing.delay_days_override',
    'payments.settlement_timing.payment_method_options.acss_debit.delay_days_override',
    'payments.settlement_timing.payment_method_options.bacs_debit.delay_days_override',
    'payments.settlement_timing.payment_method_options.sepa_debit.delay_days_override',
    'payments.settlement_timing.payment_method_options.us_bank_account.delay_days_override',
    'payments.start_of_day',
  ],
  OpenapiPostV1BalanceSettingsInputPayments: [
    'payouts.automatic_transfer_rules_by_currency',
    'payouts.default_payout_method_for_currency',
    'payouts.minimum_balance_by_currency',
    'settlement_timing.delay_days_override',
    'settlement_timing.payment_method_options.acss_debit.delay_days_override',
    'settlement_timing.payment_method_options.bacs_debit.delay_days_override',
    'settlement_timing.payment_method_options.sepa_debit.delay_days_override',
    'settlement_timing.payment_method_options.us_bank_account.delay_days_override',
    'start_of_day',
  ],
  OpenapiPostV1BalanceSettingsInputPaymentsPayouts: [
    'automatic_transfer_rules_by_currency',
    'default_payout_method_for_currency',
    'minimum_balance_by_currency',
  ],
  OpenapiPostV1BalanceSettingsInputPaymentsPayoutsAutomaticTransferRulesByCurrencyMaybeEmpty: [],
  OpenapiPostV1BalanceSettingsInputPaymentsPayoutsDefaultPayoutMethodForCurrencyMaybeEmpty: [],
  OpenapiPostV1BalanceSettingsInputPaymentsPayoutsMinimumBalanceByCurrencyMaybeEmpty: [],
  OpenapiPostV1BalanceSettingsInputPaymentsSettlementTiming: [
    'delay_days_override',
    'payment_method_options.acss_debit.delay_days_override',
    'payment_method_options.bacs_debit.delay_days_override',
    'payment_method_options.sepa_debit.delay_days_override',
    'payment_method_options.us_bank_account.delay_days_override',
  ],
  OpenapiPostV1BalanceSettingsInputPaymentsSettlementTimingDelayDaysOverrideMaybeEmpty: [],
  OpenapiPostV1BalanceSettingsInputPaymentsSettlementTimingPaymentMethodOptions: [
    'acss_debit.delay_days_override',
    'bacs_debit.delay_days_override',
    'sepa_debit.delay_days_override',
    'us_bank_account.delay_days_override',
  ],
  OpenapiPostV1BalanceSettingsInputPaymentsSettlementTimingPaymentMethodOptionsAcssDebit: [
    'delay_days_override',
  ],
  OpenapiPostV1BalanceSettingsInputPaymentsSettlementTimingPaymentMethodOptionsAcssDebitDelayDaysOverrideMaybeEmpty: [],
  OpenapiPostV1BalanceSettingsInputPaymentsSettlementTimingPaymentMethodOptionsBacsDebit: [
    'delay_days_override',
  ],
  OpenapiPostV1BalanceSettingsInputPaymentsSettlementTimingPaymentMethodOptionsBacsDebitDelayDaysOverrideMaybeEmpty: [],
  OpenapiPostV1BalanceSettingsInputPaymentsSettlementTimingPaymentMethodOptionsSepaDebit: [
    'delay_days_override',
  ],
  OpenapiPostV1BalanceSettingsInputPaymentsSettlementTimingPaymentMethodOptionsSepaDebitDelayDaysOverrideMaybeEmpty: [],
  OpenapiPostV1BalanceSettingsInputPaymentsSettlementTimingPaymentMethodOptionsUsBankAccount: [
    'delay_days_override',
  ],
  OpenapiPostV1BalanceSettingsInputPaymentsSettlementTimingPaymentMethodOptionsUsBankAccountDelayDaysOverrideMaybeEmpty: [],
  OpenapiPostV1BalanceSettingsInputPaymentsStartOfDayMaybeEmpty: [],
  OpenapiPostV1BalanceTransfersBalanceTransferInput: [
    'metadata',
  ],
  OpenapiPostV1BalanceTransfersBalanceTransferInputMetadataMaybeEmpty: [],
  OpenapiPostV1BillingCreditGrantsIdInput: [
    'expires_at',
  ],
  OpenapiPostV1BillingCreditGrantsIdInputExpiresAtMaybeEmpty: [],
  OpenapiPostV1BillingOverviewUbbMerchantSettingsInput: [
    'selected_meters',
  ],
  OpenapiPostV1BillingOverviewUbbMerchantSettingsInputSelectedMetersMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInput: [
    'features.customer_update.allowed_updates',
    'features.subscription_cancel.cancellation_reason.options',
    'features.subscription_cancel.retention_options.coupons',
    'features.subscription_update.default_allowed_updates',
    'features.subscription_update.packaging',
    'features.subscription_update.products',
    'features.subscription_update.schedule_at_period_end.conditions',
    'features.usage_based_billing.usage_analytics.group_by_dimensions',
    'metadata',
  ],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeatures: [
    'customer_update.allowed_updates',
    'subscription_cancel.cancellation_reason.options',
    'subscription_cancel.retention_options.coupons',
    'subscription_update.default_allowed_updates',
    'subscription_update.packaging',
    'subscription_update.products',
    'subscription_update.schedule_at_period_end.conditions',
    'usage_based_billing.usage_analytics.group_by_dimensions',
  ],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesCustomerUpdate: [
    'allowed_updates',
  ],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesCustomerUpdateAllowedUpdatesMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesSubscriptionCancel: [
    'cancellation_reason.options',
    'retention_options.coupons',
  ],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesSubscriptionCancelCancellationReason: [
    'options',
  ],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesSubscriptionCancelCancellationReasonOptionsMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesSubscriptionCancelRetentionOptions: [
    'coupons',
  ],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesSubscriptionCancelRetentionOptionsCouponsMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesSubscriptionUpdate: [
    'default_allowed_updates',
    'packaging',
    'products',
    'schedule_at_period_end.conditions',
  ],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesSubscriptionUpdateDefaultAllowedUpdatesMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesSubscriptionUpdatePackagingMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesSubscriptionUpdateProductsMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesSubscriptionUpdateScheduleAtPeriodEnd: [
    'conditions',
  ],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesSubscriptionUpdateScheduleAtPeriodEndConditionsMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesUsageBasedBilling: [
    'usage_analytics.group_by_dimensions',
  ],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesUsageBasedBillingUsageAnalytics: [
    'group_by_dimensions',
  ],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputFeaturesUsageBasedBillingUsageAnalyticsGroupByDimensionsMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsConfigurationInputMetadataMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsInput: [
    'features.customer_update.allowed_updates',
    'features.subscription_cancel.cancellation_reason.options',
    'features.subscription_cancel.retention_options.coupons',
    'features.subscription_update.default_allowed_updates',
    'features.subscription_update.products',
    'features.usage_based_billing.usage_analytics.group_by_dimensions',
  ],
  OpenapiPostV1BillingPortalConfigurationsInputFeatures: [
    'customer_update.allowed_updates',
    'subscription_cancel.cancellation_reason.options',
    'subscription_cancel.retention_options.coupons',
    'subscription_update.default_allowed_updates',
    'subscription_update.products',
    'usage_based_billing.usage_analytics.group_by_dimensions',
  ],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesCustomerUpdate: [
    'allowed_updates',
  ],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesCustomerUpdateAllowedUpdatesMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesSubscriptionCancel: [
    'cancellation_reason.options',
    'retention_options.coupons',
  ],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesSubscriptionCancelCancellationReason: [
    'options',
  ],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesSubscriptionCancelCancellationReasonOptionsMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesSubscriptionCancelRetentionOptions: [
    'coupons',
  ],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesSubscriptionCancelRetentionOptionsCouponsMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesSubscriptionUpdate: [
    'default_allowed_updates',
    'products',
  ],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesSubscriptionUpdateDefaultAllowedUpdatesMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesSubscriptionUpdateProductsMaybeEmpty: [],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesUsageBasedBilling: [
    'usage_analytics.group_by_dimensions',
  ],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesUsageBasedBillingUsageAnalytics: [
    'group_by_dimensions',
  ],
  OpenapiPostV1BillingPortalConfigurationsInputFeaturesUsageBasedBillingUsageAnalyticsGroupByDimensionsMaybeEmpty: [],
  OpenapiPostV1BillingPortalSessionsSessionCustomersCustomerInput: [
    'address',
    'shipping_address',
    'tax_id_data',
  ],
  OpenapiPostV1BillingPortalSessionsSessionCustomersCustomerInputAddressMaybeEmpty: [],
  OpenapiPostV1BillingPortalSessionsSessionCustomersCustomerInputShippingAddressMaybeEmpty: [],
  OpenapiPostV1BillingPortalSessionsSessionCustomersCustomerInputTaxIdDataMaybeEmpty: [],
  OpenapiPostV1BuyButtonsBuyButtonInput: [
    'branding_settings',
  ],
  OpenapiPostV1BuyButtonsBuyButtonInputBrandingSettingsMaybeEmpty: [],
  OpenapiPostV1ChargesChargeCaptureInput: [
    'payment_details.car_rental_data',
    'payment_details.flight_data',
    'payment_details.lodging_data',
  ],
  OpenapiPostV1ChargesChargeCaptureInputPaymentDetails: [
    'car_rental_data',
    'flight_data',
    'lodging_data',
  ],
  OpenapiPostV1ChargesChargeCaptureInputPaymentDetailsCarRentalDataMaybeEmpty: [],
  OpenapiPostV1ChargesChargeCaptureInputPaymentDetailsFlightDataMaybeEmpty: [],
  OpenapiPostV1ChargesChargeCaptureInputPaymentDetailsLodgingDataMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInput: [
    'metadata',
    'payment_details.car_rental_data',
    'payment_details.flight_data',
    'payment_details.lodging_data',
    'revenue_recognition_settings',
    'supporting_dispute_evidence',
    'supporting_dispute_evidence.booking',
    'supporting_dispute_evidence.booking.end_date',
    'supporting_dispute_evidence.booking.start_date',
    'supporting_dispute_evidence.credit_voucher',
    'supporting_dispute_evidence.credit_voucher.amount',
    'supporting_dispute_evidence.credit_voucher.created',
    'supporting_dispute_evidence.credit_voucher.expires_after',
    'supporting_dispute_evidence.event_details',
    'supporting_dispute_evidence.event_details.original_date',
    'supporting_dispute_evidence.event_details.rescheduled_date',
    'supporting_dispute_evidence.prior_undisputed_payments',
  ],
  OpenapiPostV1ChargesChargeInputMetadataMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInputPaymentDetails: [
    'car_rental_data',
    'flight_data',
    'lodging_data',
  ],
  OpenapiPostV1ChargesChargeInputPaymentDetailsCarRentalDataMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInputPaymentDetailsFlightDataMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInputPaymentDetailsLodgingDataMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInputRevenueRecognitionSettingsMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidence: [
    'booking',
    'booking.end_date',
    'booking.start_date',
    'credit_voucher',
    'credit_voucher.amount',
    'credit_voucher.created',
    'credit_voucher.expires_after',
    'event_details',
    'event_details.original_date',
    'event_details.rescheduled_date',
    'prior_undisputed_payments',
  ],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceBooking: [
    'end_date',
    'start_date',
  ],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceBookingEndDateMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceBookingMaybeEmpty: [
    'end_date',
    'start_date',
  ],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceBookingStartDateMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceCreditVoucher: [
    'amount',
    'created',
    'expires_after',
  ],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceCreditVoucherAmountMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceCreditVoucherCreatedMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceCreditVoucherExpiresAfterMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceCreditVoucherMaybeEmpty: [
    'amount',
    'created',
    'expires_after',
  ],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceEventDetails: [
    'original_date',
    'rescheduled_date',
  ],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceEventDetailsMaybeEmpty: [
    'original_date',
    'rescheduled_date',
  ],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceEventDetailsOriginalDateMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceEventDetailsRescheduledDateMaybeEmpty: [],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidenceMaybeEmpty: [
    'booking',
    'booking.end_date',
    'booking.start_date',
    'credit_voucher',
    'credit_voucher.amount',
    'credit_voucher.created',
    'credit_voucher.expires_after',
    'event_details',
    'event_details.original_date',
    'event_details.rescheduled_date',
    'prior_undisputed_payments',
  ],
  OpenapiPostV1ChargesChargeInputSupportingDisputeEvidencePriorUndisputedPaymentsMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsInput: [
    'custom_text.after_submit',
    'custom_text.shipping_address',
    'custom_text.submit',
    'custom_text.terms_of_service_acceptance',
    'discounts.coupon_data.metadata',
    'invoice_creation.invoice_data.account_tax_ids',
    'invoice_creation.invoice_data.custom_fields',
    'invoice_creation.invoice_data.rendering_options',
    'payment_method_options.klarna.subscriptions',
    'payment_method_options.payto.mandate_options.amount',
    'payment_method_options.payto.mandate_options.payments_per_period',
  ],
  OpenapiPostV1CheckoutSessionsInputCustomText: [
    'after_submit',
    'shipping_address',
    'submit',
    'terms_of_service_acceptance',
  ],
  OpenapiPostV1CheckoutSessionsInputCustomTextAfterSubmitMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsInputCustomTextShippingAddressMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsInputCustomTextSubmitMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsInputCustomTextTermsOfServiceAcceptanceMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsInputDiscounts: [
    'coupon_data.metadata',
  ],
  OpenapiPostV1CheckoutSessionsInputDiscountsCouponData: [
    'metadata',
  ],
  OpenapiPostV1CheckoutSessionsInputDiscountsCouponDataMetadataMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsInputInvoiceCreation: [
    'invoice_data.account_tax_ids',
    'invoice_data.custom_fields',
    'invoice_data.rendering_options',
  ],
  OpenapiPostV1CheckoutSessionsInputInvoiceCreationInvoiceData: [
    'account_tax_ids',
    'custom_fields',
    'rendering_options',
  ],
  OpenapiPostV1CheckoutSessionsInputInvoiceCreationInvoiceDataAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsInputInvoiceCreationInvoiceDataCustomFieldsMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsInputInvoiceCreationInvoiceDataRenderingOptionsMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsInputPaymentMethodOptions: [
    'klarna.subscriptions',
    'payto.mandate_options.amount',
    'payto.mandate_options.payments_per_period',
  ],
  OpenapiPostV1CheckoutSessionsInputPaymentMethodOptionsKlarna: [
    'subscriptions',
  ],
  OpenapiPostV1CheckoutSessionsInputPaymentMethodOptionsKlarnaSubscriptionsMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsInputPaymentMethodOptionsPayto: [
    'mandate_options.amount',
    'mandate_options.payments_per_period',
  ],
  OpenapiPostV1CheckoutSessionsInputPaymentMethodOptionsPaytoMandateOptions: [
    'amount',
    'payments_per_period',
  ],
  OpenapiPostV1CheckoutSessionsInputPaymentMethodOptionsPaytoMandateOptionsAmountMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsInputPaymentMethodOptionsPaytoMandateOptionsPaymentsPerPeriodMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsSessionInput: [
    'credits',
    'discounts',
    'discounts.coupon_data.metadata',
    'line_items.metadata',
    'line_items.tax_rates',
    'metadata',
    'shipping_options',
    'subscription_data.pending_invoice_item_interval',
    'subscription_data.trial_period_days',
  ],
  OpenapiPostV1CheckoutSessionsSessionInputCreditsMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsSessionInputDiscounts: [
    'coupon_data.metadata',
  ],
  OpenapiPostV1CheckoutSessionsSessionInputDiscountsCouponData: [
    'metadata',
  ],
  OpenapiPostV1CheckoutSessionsSessionInputDiscountsCouponDataMetadataMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsSessionInputDiscountsMaybeEmpty: [
    'coupon_data.metadata',
  ],
  OpenapiPostV1CheckoutSessionsSessionInputLineItems: [
    'metadata',
    'tax_rates',
  ],
  OpenapiPostV1CheckoutSessionsSessionInputLineItemsMetadataMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsSessionInputLineItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsSessionInputMetadataMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsSessionInputShippingOptionsMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsSessionInputSubscriptionData: [
    'pending_invoice_item_interval',
    'trial_period_days',
  ],
  OpenapiPostV1CheckoutSessionsSessionInputSubscriptionDataPendingInvoiceItemIntervalMaybeEmpty: [],
  OpenapiPostV1CheckoutSessionsSessionInputSubscriptionDataTrialPeriodDaysMaybeEmpty: [],
  OpenapiPostV1ClimateOrdersOrderInput: [
    'beneficiary',
  ],
  OpenapiPostV1ClimateOrdersOrderInputBeneficiaryMaybeEmpty: [],
  OpenapiPostV1ClimateProgramInput: [
    'contribution_flat_amount',
    'contribution_rate_percent',
  ],
  OpenapiPostV1ClimateProgramInputContributionFlatAmountMaybeEmpty: [],
  OpenapiPostV1ClimateProgramInputContributionRatePercentMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInput: [
    'pricing_config.application_fees',
    'pricing_config.dispute_fees.additional_fees',
    'pricing_config.dispute_fees.additional_markups',
    'pricing_config.dispute_fees.value',
    'pricing_config.instant_payout_fees.additional_fees',
    'pricing_config.instant_payout_fees.additional_markups',
    'pricing_config.instant_payout_fees.value',
    'pricing_config.payment_fees.additional_fees',
    'pricing_config.payment_fees.additional_markups',
    'pricing_config.payment_fees.value',
    'scheduled_pricing_config.payment_fees.additional_fees',
    'scheduled_pricing_config.payment_fees.additional_markups',
    'scheduled_pricing_config.payment_fees.value',
  ],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfig: [
    'application_fees',
    'dispute_fees.additional_fees',
    'dispute_fees.additional_markups',
    'dispute_fees.value',
    'instant_payout_fees.additional_fees',
    'instant_payout_fees.additional_markups',
    'instant_payout_fees.value',
    'payment_fees.additional_fees',
    'payment_fees.additional_markups',
    'payment_fees.value',
  ],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigApplicationFeesMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigDisputeFees: [
    'additional_fees',
    'additional_markups',
    'value',
  ],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigDisputeFeesAdditionalFeesMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigDisputeFeesAdditionalMarkupsMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigDisputeFeesValueMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigInstantPayoutFees: [
    'additional_fees',
    'additional_markups',
    'value',
  ],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigInstantPayoutFeesAdditionalFeesMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigInstantPayoutFeesAdditionalMarkupsMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigInstantPayoutFeesValueMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigPaymentFees: [
    'additional_fees',
    'additional_markups',
    'value',
  ],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigPaymentFeesAdditionalFeesMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigPaymentFeesAdditionalMarkupsMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputPricingConfigPaymentFeesValueMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputScheduledPricingConfig: [
    'payment_fees.additional_fees',
    'payment_fees.additional_markups',
    'payment_fees.value',
  ],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputScheduledPricingConfigPaymentFees: [
    'additional_fees',
    'additional_markups',
    'value',
  ],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputScheduledPricingConfigPaymentFeesAdditionalFeesMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputScheduledPricingConfigPaymentFeesAdditionalMarkupsMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesInputScheduledPricingConfigPaymentFeesValueMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInput: [
    'pricing_config.application_fees',
    'pricing_config.dispute_fees.additional_fees',
    'pricing_config.dispute_fees.additional_markups',
    'pricing_config.dispute_fees.value',
    'pricing_config.instant_payout_fees.additional_fees',
    'pricing_config.instant_payout_fees.additional_markups',
    'pricing_config.instant_payout_fees.value',
    'pricing_config.payment_fees.additional_fees',
    'pricing_config.payment_fees.additional_markups',
    'pricing_config.payment_fees.value',
  ],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfig: [
    'application_fees',
    'dispute_fees.additional_fees',
    'dispute_fees.additional_markups',
    'dispute_fees.value',
    'instant_payout_fees.additional_fees',
    'instant_payout_fees.additional_markups',
    'instant_payout_fees.value',
    'payment_fees.additional_fees',
    'payment_fees.additional_markups',
    'payment_fees.value',
  ],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigApplicationFeesMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigDisputeFees: [
    'additional_fees',
    'additional_markups',
    'value',
  ],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigDisputeFeesAdditionalFeesMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigDisputeFeesAdditionalMarkupsMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigDisputeFeesValueMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigInstantPayoutFees: [
    'additional_fees',
    'additional_markups',
    'value',
  ],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigInstantPayoutFeesAdditionalFeesMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigInstantPayoutFeesAdditionalMarkupsMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigInstantPayoutFeesValueMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigPaymentFees: [
    'additional_fees',
    'additional_markups',
    'value',
  ],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigPaymentFeesAdditionalFeesMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigPaymentFeesAdditionalMarkupsMaybeEmpty: [],
  OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInputPricingConfigPaymentFeesValueMaybeEmpty: [],
  OpenapiPostV1ConnectW8W9CollectionW8W9PlatformConfigInput: [
    'w8_w9_platform_config.us_w8_or_w9_w8_income_types',
  ],
  OpenapiPostV1ConnectW8W9CollectionW8W9PlatformConfigInputW8W9PlatformConfig: [
    'us_w8_or_w9_w8_income_types',
  ],
  OpenapiPostV1ConnectW8W9CollectionW8W9PlatformConfigInputW8W9PlatformConfigUsW8OrW9W8IncomeTypesMaybeEmpty: [],
  OpenapiPostV1CouponsInput: [
    'metadata',
  ],
  OpenapiPostV1CouponsInputMetadataMaybeEmpty: [],
  OpenapiPostV1CreditNotesInput: [
    'lines.tax_amounts',
    'lines.tax_rates',
  ],
  OpenapiPostV1CreditNotesInputLines: [
    'tax_amounts',
    'tax_rates',
  ],
  OpenapiPostV1CreditNotesInputLinesTaxAmountsMaybeEmpty: [],
  OpenapiPostV1CreditNotesInputLinesTaxRatesMaybeEmpty: [],
  OpenapiPostV1CustomersBlockedBillingAddressCountriesInput: [
    'countries',
  ],
  OpenapiPostV1CustomersBlockedBillingAddressCountriesInputCountriesMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInput: [
    'additional_emails.cc',
    'additional_emails.to',
    'address',
    'application_fee_percent',
    'billing_thresholds',
    'invoice_settings.custom_fields',
    'invoice_settings.rendering_options',
    'items.billing_thresholds',
    'items.discounts',
    'items.metadata',
    'items.tax_rates',
    'metadata',
    'pending_invoice_item_interval',
    'shipping',
    'tax_percent',
  ],
  OpenapiPostV1CustomersCustomerInputAdditionalEmails: [
    'cc',
    'to',
  ],
  OpenapiPostV1CustomersCustomerInputAdditionalEmailsCcMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputAdditionalEmailsToMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputAddressMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputApplicationFeePercentMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputInvoiceSettings: [
    'custom_fields',
    'rendering_options',
  ],
  OpenapiPostV1CustomersCustomerInputInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputInvoiceSettingsRenderingOptionsMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputItems: [
    'billing_thresholds',
    'discounts',
    'metadata',
    'tax_rates',
  ],
  OpenapiPostV1CustomersCustomerInputItemsBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputItemsDiscountsMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputItemsMetadataMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputMetadataMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputPendingInvoiceItemIntervalMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputShippingMaybeEmpty: [],
  OpenapiPostV1CustomersCustomerInputTaxPercentMaybeEmpty: [],
  OpenapiPostV1CustomersInput: [
    'additional_emails.cc',
    'additional_emails.to',
    'address',
    'application_fee_percent',
    'billing_thresholds',
    'invoice_settings.custom_fields',
    'invoice_settings.rendering_options',
    'items.billing_thresholds',
    'items.discounts',
    'items.metadata',
    'items.tax_rates',
    'metadata',
    'pending_invoice_item_interval',
    'shipping',
    'tax_percent',
  ],
  OpenapiPostV1CustomersInputAdditionalEmails: [
    'cc',
    'to',
  ],
  OpenapiPostV1CustomersInputAdditionalEmailsCcMaybeEmpty: [],
  OpenapiPostV1CustomersInputAdditionalEmailsToMaybeEmpty: [],
  OpenapiPostV1CustomersInputAddressMaybeEmpty: [],
  OpenapiPostV1CustomersInputApplicationFeePercentMaybeEmpty: [],
  OpenapiPostV1CustomersInputBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1CustomersInputInvoiceSettings: [
    'custom_fields',
    'rendering_options',
  ],
  OpenapiPostV1CustomersInputInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1CustomersInputInvoiceSettingsRenderingOptionsMaybeEmpty: [],
  OpenapiPostV1CustomersInputItems: [
    'billing_thresholds',
    'discounts',
    'metadata',
    'tax_rates',
  ],
  OpenapiPostV1CustomersInputItemsBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1CustomersInputItemsDiscountsMaybeEmpty: [],
  OpenapiPostV1CustomersInputItemsMetadataMaybeEmpty: [],
  OpenapiPostV1CustomersInputItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1CustomersInputMetadataMaybeEmpty: [],
  OpenapiPostV1CustomersInputPendingInvoiceItemIntervalMaybeEmpty: [],
  OpenapiPostV1CustomersInputShippingMaybeEmpty: [],
  OpenapiPostV1CustomersInputTaxPercentMaybeEmpty: [],
  OpenapiPostV1DisputesDisputeInput: [
    'evidence.booking',
    'evidence.booking.end_date',
    'evidence.booking.start_date',
    'evidence.credit_voucher',
    'evidence.credit_voucher.amount',
    'evidence.credit_voucher.created',
    'evidence.credit_voucher.expires_after',
    'evidence.enhanced_evidence',
    'evidence.event_details',
    'evidence.event_details.original_date',
    'evidence.event_details.rescheduled_date',
    'evidence.prior_undisputed_payments',
    'evidence.uncategorized_data',
    'metadata',
  ],
  OpenapiPostV1DisputesDisputeInputEvidence: [
    'booking',
    'booking.end_date',
    'booking.start_date',
    'credit_voucher',
    'credit_voucher.amount',
    'credit_voucher.created',
    'credit_voucher.expires_after',
    'enhanced_evidence',
    'event_details',
    'event_details.original_date',
    'event_details.rescheduled_date',
    'prior_undisputed_payments',
    'uncategorized_data',
  ],
  OpenapiPostV1DisputesDisputeInputEvidenceBooking: [
    'end_date',
    'start_date',
  ],
  OpenapiPostV1DisputesDisputeInputEvidenceBookingEndDateMaybeEmpty: [],
  OpenapiPostV1DisputesDisputeInputEvidenceBookingMaybeEmpty: [
    'end_date',
    'start_date',
  ],
  OpenapiPostV1DisputesDisputeInputEvidenceBookingStartDateMaybeEmpty: [],
  OpenapiPostV1DisputesDisputeInputEvidenceCreditVoucher: [
    'amount',
    'created',
    'expires_after',
  ],
  OpenapiPostV1DisputesDisputeInputEvidenceCreditVoucherAmountMaybeEmpty: [],
  OpenapiPostV1DisputesDisputeInputEvidenceCreditVoucherCreatedMaybeEmpty: [],
  OpenapiPostV1DisputesDisputeInputEvidenceCreditVoucherExpiresAfterMaybeEmpty: [],
  OpenapiPostV1DisputesDisputeInputEvidenceCreditVoucherMaybeEmpty: [
    'amount',
    'created',
    'expires_after',
  ],
  OpenapiPostV1DisputesDisputeInputEvidenceEnhancedEvidenceMaybeEmpty: [],
  OpenapiPostV1DisputesDisputeInputEvidenceEventDetails: [
    'original_date',
    'rescheduled_date',
  ],
  OpenapiPostV1DisputesDisputeInputEvidenceEventDetailsMaybeEmpty: [
    'original_date',
    'rescheduled_date',
  ],
  OpenapiPostV1DisputesDisputeInputEvidenceEventDetailsOriginalDateMaybeEmpty: [],
  OpenapiPostV1DisputesDisputeInputEvidenceEventDetailsRescheduledDateMaybeEmpty: [],
  OpenapiPostV1DisputesDisputeInputEvidencePriorUndisputedPaymentsMaybeEmpty: [],
  OpenapiPostV1DisputesDisputeInputEvidenceUncategorizedDataMaybeEmpty: [],
  OpenapiPostV1DisputesDisputeInputMetadataMaybeEmpty: [],
  OpenapiPostV1EntitlementsFeaturesIdInput: [
    'metadata',
  ],
  OpenapiPostV1EntitlementsFeaturesIdInputMetadataMaybeEmpty: [],
  OpenapiPostV1FileLinksInput: [
    'metadata',
  ],
  OpenapiPostV1FileLinksInputMetadataMaybeEmpty: [],
  OpenapiPostV1GiftCardsCardsIdInput: [
    'metadata',
  ],
  OpenapiPostV1GiftCardsCardsIdInputMetadataMaybeEmpty: [],
  OpenapiPostV1IamRoleAssignmentsPrincipalInput: [
    'role_assignments',
  ],
  OpenapiPostV1IamRoleAssignmentsPrincipalInputRoleAssignmentsMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsInput: [
    'options.document',
    'options.duplicate',
    'options.email',
    'options.id_number',
    'options.matching',
    'options.phone',
    'options.phone_otp',
    'options.phone_records',
  ],
  OpenapiPostV1IdentityVerificationSessionsInputOptions: [
    'document',
    'duplicate',
    'email',
    'id_number',
    'matching',
    'phone',
    'phone_otp',
    'phone_records',
  ],
  OpenapiPostV1IdentityVerificationSessionsInputOptionsDocumentMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsInputOptionsDuplicateMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsInputOptionsEmailMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsInputOptionsIdNumberMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsInputOptionsMatchingMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsInputOptionsPhoneMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsInputOptionsPhoneOtpMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsInputOptionsPhoneRecordsMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsSessionInput: [
    'options.document',
    'options.duplicate',
    'options.email',
    'options.id_number',
    'options.matching',
    'options.phone',
    'options.phone_otp',
    'options.phone_records',
  ],
  OpenapiPostV1IdentityVerificationSessionsSessionInputOptions: [
    'document',
    'duplicate',
    'email',
    'id_number',
    'matching',
    'phone',
    'phone_otp',
    'phone_records',
  ],
  OpenapiPostV1IdentityVerificationSessionsSessionInputOptionsDocumentMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsSessionInputOptionsDuplicateMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsSessionInputOptionsEmailMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsSessionInputOptionsIdNumberMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsSessionInputOptionsMatchingMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsSessionInputOptionsPhoneMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsSessionInputOptionsPhoneOtpMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationSessionsSessionInputOptionsPhoneRecordsMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesInput: [
    'options.document',
    'options.duplicate',
    'options.email',
    'options.id_number',
    'options.matching',
    'options.phone',
    'options.phone_otp',
    'options.phone_records',
  ],
  OpenapiPostV1IdentityVerificationTemplatesInputOptions: [
    'document',
    'duplicate',
    'email',
    'id_number',
    'matching',
    'phone',
    'phone_otp',
    'phone_records',
  ],
  OpenapiPostV1IdentityVerificationTemplatesInputOptionsDocumentMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesInputOptionsDuplicateMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesInputOptionsEmailMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesInputOptionsIdNumberMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesInputOptionsMatchingMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesInputOptionsPhoneMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesInputOptionsPhoneOtpMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesInputOptionsPhoneRecordsMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesTemplateInput: [
    'options.document',
    'options.duplicate',
    'options.email',
    'options.id_number',
    'options.matching',
    'options.phone',
    'options.phone_otp',
    'options.phone_records',
  ],
  OpenapiPostV1IdentityVerificationTemplatesTemplateInputOptions: [
    'document',
    'duplicate',
    'email',
    'id_number',
    'matching',
    'phone',
    'phone_otp',
    'phone_records',
  ],
  OpenapiPostV1IdentityVerificationTemplatesTemplateInputOptionsDocumentMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesTemplateInputOptionsDuplicateMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesTemplateInputOptionsEmailMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesTemplateInputOptionsIdNumberMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesTemplateInputOptionsMatchingMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesTemplateInputOptionsPhoneMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesTemplateInputOptionsPhoneOtpMaybeEmpty: [],
  OpenapiPostV1IdentityVerificationTemplatesTemplateInputOptionsPhoneRecordsMaybeEmpty: [],
  OpenapiPostV1InternalRubyWriteFirstInput: [
    'array_param',
    'boolean_param',
    'float_param',
    'integer_param',
    'map_param',
  ],
  OpenapiPostV1InternalRubyWriteFirstInputArrayParamMaybeEmpty: [],
  OpenapiPostV1InternalRubyWriteFirstInputBooleanParamMaybeEmpty: [],
  OpenapiPostV1InternalRubyWriteFirstInputFloatParamMaybeEmpty: [],
  OpenapiPostV1InternalRubyWriteFirstInputIntegerParamMaybeEmpty: [],
  OpenapiPostV1InternalRubyWriteFirstInputMapParamMaybeEmpty: [],
  OpenapiPostV1InventoriesIdInput: [
    'metadata',
  ],
  OpenapiPostV1InventoriesIdInputMetadataMaybeEmpty: [],
  OpenapiPostV1InvoiceRenderingTemplatesInput: [
    'fields.custom_fields_static',
  ],
  OpenapiPostV1InvoiceRenderingTemplatesInputFields: [
    'custom_fields_static',
  ],
  OpenapiPostV1InvoiceRenderingTemplatesInputFieldsCustomFieldsStaticMaybeEmpty: [],
  OpenapiPostV1InvoiceRenderingTemplatesTemplateInput: [
    'fields.custom_fields_static',
    'line_item_policy',
    'metadata',
    'summary_item_policies',
  ],
  OpenapiPostV1InvoiceRenderingTemplatesTemplateInputFields: [
    'custom_fields_static',
  ],
  OpenapiPostV1InvoiceRenderingTemplatesTemplateInputFieldsCustomFieldsStaticMaybeEmpty: [],
  OpenapiPostV1InvoiceRenderingTemplatesTemplateInputLineItemPolicyMaybeEmpty: [],
  OpenapiPostV1InvoiceRenderingTemplatesTemplateInputMetadataMaybeEmpty: [],
  OpenapiPostV1InvoiceRenderingTemplatesTemplateInputSummaryItemPoliciesMaybeEmpty: [],
  OpenapiPostV1InvoiceitemsInput: [
    'discounts',
    'metadata',
    'revenue_recognition_settings',
  ],
  OpenapiPostV1InvoiceitemsInputDiscountsMaybeEmpty: [],
  OpenapiPostV1InvoiceitemsInputMetadataMaybeEmpty: [],
  OpenapiPostV1InvoiceitemsInputRevenueRecognitionSettingsMaybeEmpty: [],
  OpenapiPostV1InvoicesInput: [
    'account_tax_ids',
    'amounts_due',
    'amounts_due.deposit',
    'amounts_due.percent',
    'attachments',
    'custom_fields',
    'discounts',
    'metadata',
    'payment_settings.payment_method_options.acss_debit',
    'payment_settings.payment_method_options.bancontact',
    'payment_settings.payment_method_options.card',
    'payment_settings.payment_method_options.card.installments.plan',
    'payment_settings.payment_method_options.customer_balance',
    'payment_settings.payment_method_options.id_bank_transfer',
    'payment_settings.payment_method_options.konbini',
    'payment_settings.payment_method_options.payto',
    'payment_settings.payment_method_options.pix',
    'payment_settings.payment_method_options.sepa_debit',
    'payment_settings.payment_method_options.upi',
    'payment_settings.payment_method_options.us_bank_account',
    'payment_settings.payment_method_types',
    'rendering.summary_items_data',
    'rendering.template_version',
    'rendering_options',
    'revenue_recognition_settings',
  ],
  OpenapiPostV1InvoicesInputAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1InvoicesInputAmountsDue: [
    'deposit',
    'percent',
  ],
  OpenapiPostV1InvoicesInputAmountsDueDepositMaybeEmpty: [],
  OpenapiPostV1InvoicesInputAmountsDueMaybeEmpty: [
    'deposit',
    'percent',
  ],
  OpenapiPostV1InvoicesInputAmountsDuePercentMaybeEmpty: [],
  OpenapiPostV1InvoicesInputAttachmentsMaybeEmpty: [],
  OpenapiPostV1InvoicesInputCustomFieldsMaybeEmpty: [],
  OpenapiPostV1InvoicesInputDiscountsMaybeEmpty: [],
  OpenapiPostV1InvoicesInputMetadataMaybeEmpty: [],
  OpenapiPostV1InvoicesInputPaymentSettings: [
    'payment_method_options.acss_debit',
    'payment_method_options.bancontact',
    'payment_method_options.card',
    'payment_method_options.card.installments.plan',
    'payment_method_options.customer_balance',
    'payment_method_options.id_bank_transfer',
    'payment_method_options.konbini',
    'payment_method_options.payto',
    'payment_method_options.pix',
    'payment_method_options.sepa_debit',
    'payment_method_options.upi',
    'payment_method_options.us_bank_account',
    'payment_method_types',
  ],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptions: [
    'acss_debit',
    'bancontact',
    'card',
    'card.installments.plan',
    'customer_balance',
    'id_bank_transfer',
    'konbini',
    'payto',
    'pix',
    'sepa_debit',
    'upi',
    'us_bank_account',
  ],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsAcssDebitMaybeEmpty: [],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsBancontactMaybeEmpty: [],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsCard: [
    'installments.plan',
  ],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsCardInstallments: [
    'plan',
  ],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsCardInstallmentsPlanMaybeEmpty: [],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsCardMaybeEmpty: [
    'installments.plan',
  ],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsCustomerBalanceMaybeEmpty: [],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsIdBankTransferMaybeEmpty: [],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsKonbiniMaybeEmpty: [],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsPaytoMaybeEmpty: [],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsPixMaybeEmpty: [],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsSepaDebitMaybeEmpty: [],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsUpiMaybeEmpty: [],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiPostV1InvoicesInputPaymentSettingsPaymentMethodTypesMaybeEmpty: [],
  OpenapiPostV1InvoicesInputRendering: [
    'summary_items_data',
    'template_version',
  ],
  OpenapiPostV1InvoicesInputRenderingOptionsMaybeEmpty: [],
  OpenapiPostV1InvoicesInputRenderingSummaryItemsDataMaybeEmpty: [],
  OpenapiPostV1InvoicesInputRenderingTemplateVersionMaybeEmpty: [],
  OpenapiPostV1InvoicesInputRevenueRecognitionSettingsMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceAttachPaymentInput: [
    'out_of_band_payment.metadata',
    'payment_record_data.metadata',
  ],
  OpenapiPostV1InvoicesInvoiceAttachPaymentInputOutOfBandPayment: [
    'metadata',
  ],
  OpenapiPostV1InvoicesInvoiceAttachPaymentInputOutOfBandPaymentMetadataMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceAttachPaymentInputPaymentRecordData: [
    'metadata',
  ],
  OpenapiPostV1InvoicesInvoiceAttachPaymentInputPaymentRecordDataMetadataMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInput: [
    'account_tax_ids',
    'amounts_due',
    'amounts_due.deposit',
    'amounts_due.percent',
    'attachments',
    'custom_fields',
    'default_margins',
    'default_tax_rates',
    'discounts',
    'effective_at',
    'metadata',
    'payment_settings.payment_method_options.acss_debit',
    'payment_settings.payment_method_options.bancontact',
    'payment_settings.payment_method_options.card',
    'payment_settings.payment_method_options.card.installments.plan',
    'payment_settings.payment_method_options.customer_balance',
    'payment_settings.payment_method_options.id_bank_transfer',
    'payment_settings.payment_method_options.konbini',
    'payment_settings.payment_method_options.payto',
    'payment_settings.payment_method_options.pix',
    'payment_settings.payment_method_options.sepa_debit',
    'payment_settings.payment_method_options.upi',
    'payment_settings.payment_method_options.us_bank_account',
    'payment_settings.payment_method_types',
    'rendering.summary_items_data',
    'rendering.template_version',
    'rendering_options',
    'revenue_recognition_settings',
    'shipping_cost',
    'shipping_details',
    'tax_percent',
    'transfer_data',
  ],
  OpenapiPostV1InvoicesInvoiceInputAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputAmountsDue: [
    'deposit',
    'percent',
  ],
  OpenapiPostV1InvoicesInvoiceInputAmountsDueDepositMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputAmountsDueMaybeEmpty: [
    'deposit',
    'percent',
  ],
  OpenapiPostV1InvoicesInvoiceInputAmountsDuePercentMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputAttachmentsMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputCustomFieldsMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputDefaultMarginsMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputDefaultTaxRatesMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputDiscountsMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputEffectiveAtMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputMetadataMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettings: [
    'payment_method_options.acss_debit',
    'payment_method_options.bancontact',
    'payment_method_options.card',
    'payment_method_options.card.installments.plan',
    'payment_method_options.customer_balance',
    'payment_method_options.id_bank_transfer',
    'payment_method_options.konbini',
    'payment_method_options.payto',
    'payment_method_options.pix',
    'payment_method_options.sepa_debit',
    'payment_method_options.upi',
    'payment_method_options.us_bank_account',
    'payment_method_types',
  ],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptions: [
    'acss_debit',
    'bancontact',
    'card',
    'card.installments.plan',
    'customer_balance',
    'id_bank_transfer',
    'konbini',
    'payto',
    'pix',
    'sepa_debit',
    'upi',
    'us_bank_account',
  ],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsAcssDebitMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsBancontactMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsCard: [
    'installments.plan',
  ],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsCardInstallments: [
    'plan',
  ],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsCardInstallmentsPlanMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsCardMaybeEmpty: [
    'installments.plan',
  ],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsCustomerBalanceMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsIdBankTransferMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsKonbiniMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsPaytoMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsPixMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsSepaDebitMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsUpiMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputPaymentSettingsPaymentMethodTypesMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputRendering: [
    'summary_items_data',
    'template_version',
  ],
  OpenapiPostV1InvoicesInvoiceInputRenderingOptionsMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputRenderingSummaryItemsDataMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputRenderingTemplateVersionMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputRevenueRecognitionSettingsMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputShippingCostMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputShippingDetailsMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputTaxPercentMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoiceInputTransferDataMaybeEmpty: [],
  OpenapiPostV1InvoicesInvoicePayInput: [
    'payment_record_data.metadata',
  ],
  OpenapiPostV1InvoicesInvoicePayInputPaymentRecordData: [
    'metadata',
  ],
  OpenapiPostV1InvoicesInvoicePayInputPaymentRecordDataMetadataMaybeEmpty: [],
  OpenapiPostV1IssuingAuthorizationsAuthorizationInput: [
    'metadata',
  ],
  OpenapiPostV1IssuingAuthorizationsAuthorizationInputMetadataMaybeEmpty: [],
  OpenapiPostV1IssuingCardsCardInput: [
    'authorization_controls.allowed_merchant_currencies',
    'authorization_controls.blocked_merchant_currencies',
    'metadata',
    'multi_factor_authentication_override',
    'spending_controls.allowed_merchant_currencies',
    'spending_controls.blocked_merchant_currencies',
  ],
  OpenapiPostV1IssuingCardsCardInputAuthorizationControls: [
    'allowed_merchant_currencies',
    'blocked_merchant_currencies',
  ],
  OpenapiPostV1IssuingCardsCardInputAuthorizationControlsAllowedMerchantCurrenciesMaybeEmpty: [],
  OpenapiPostV1IssuingCardsCardInputAuthorizationControlsBlockedMerchantCurrenciesMaybeEmpty: [],
  OpenapiPostV1IssuingCardsCardInputMetadataMaybeEmpty: [],
  OpenapiPostV1IssuingCardsCardInputMultiFactorAuthenticationOverrideMaybeEmpty: [],
  OpenapiPostV1IssuingCardsCardInputSpendingControls: [
    'allowed_merchant_currencies',
    'blocked_merchant_currencies',
  ],
  OpenapiPostV1IssuingCardsCardInputSpendingControlsAllowedMerchantCurrenciesMaybeEmpty: [],
  OpenapiPostV1IssuingCardsCardInputSpendingControlsBlockedMerchantCurrenciesMaybeEmpty: [],
  OpenapiPostV1IssuingCardsInput: [
    'authorization_controls.allowed_merchant_currencies',
    'authorization_controls.blocked_merchant_currencies',
    'spending_controls.allowed_merchant_currencies',
    'spending_controls.blocked_merchant_currencies',
  ],
  OpenapiPostV1IssuingCardsInputAuthorizationControls: [
    'allowed_merchant_currencies',
    'blocked_merchant_currencies',
  ],
  OpenapiPostV1IssuingCardsInputAuthorizationControlsAllowedMerchantCurrenciesMaybeEmpty: [],
  OpenapiPostV1IssuingCardsInputAuthorizationControlsBlockedMerchantCurrenciesMaybeEmpty: [],
  OpenapiPostV1IssuingCardsInputSpendingControls: [
    'allowed_merchant_currencies',
    'blocked_merchant_currencies',
  ],
  OpenapiPostV1IssuingCardsInputSpendingControlsAllowedMerchantCurrenciesMaybeEmpty: [],
  OpenapiPostV1IssuingCardsInputSpendingControlsBlockedMerchantCurrenciesMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInput: [
    'evidence.canceled',
    'evidence.canceled.canceled_at',
    'evidence.canceled.cancellation_policy_provided',
    'evidence.canceled.expected_at',
    'evidence.canceled.returned_at',
    'evidence.duplicate',
    'evidence.fraudulent',
    'evidence.merchandise_not_as_described',
    'evidence.merchandise_not_as_described.received_at',
    'evidence.merchandise_not_as_described.returned_at',
    'evidence.no_valid_authorization',
    'evidence.not_received',
    'evidence.not_received.expected_at',
    'evidence.other',
    'evidence.product_not_received',
    'evidence.product_not_received.expected_at',
    'evidence.service_not_as_described',
    'evidence.service_not_as_described.canceled_at',
    'evidence.service_not_as_described.received_at',
    'metadata',
  ],
  OpenapiPostV1IssuingDisputesDisputeInputEvidence: [
    'canceled',
    'canceled.canceled_at',
    'canceled.cancellation_policy_provided',
    'canceled.expected_at',
    'canceled.returned_at',
    'duplicate',
    'fraudulent',
    'merchandise_not_as_described',
    'merchandise_not_as_described.received_at',
    'merchandise_not_as_described.returned_at',
    'no_valid_authorization',
    'not_received',
    'not_received.expected_at',
    'other',
    'product_not_received',
    'product_not_received.expected_at',
    'service_not_as_described',
    'service_not_as_described.canceled_at',
    'service_not_as_described.received_at',
  ],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceCanceled: [
    'canceled_at',
    'cancellation_policy_provided',
    'expected_at',
    'returned_at',
  ],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceCanceledCanceledAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceCanceledCancellationPolicyProvidedMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceCanceledExpectedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceCanceledMaybeEmpty: [
    'canceled_at',
    'cancellation_policy_provided',
    'expected_at',
    'returned_at',
  ],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceCanceledReturnedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceDuplicateMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceFraudulentMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceMerchandiseNotAsDescribed: [
    'received_at',
    'returned_at',
  ],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceMerchandiseNotAsDescribedMaybeEmpty: [
    'received_at',
    'returned_at',
  ],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceMerchandiseNotAsDescribedReceivedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceMerchandiseNotAsDescribedReturnedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceNoValidAuthorizationMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceNotReceived: [
    'expected_at',
  ],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceNotReceivedExpectedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceNotReceivedMaybeEmpty: [
    'expected_at',
  ],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceOtherMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceProductNotReceived: [
    'expected_at',
  ],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceProductNotReceivedExpectedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceProductNotReceivedMaybeEmpty: [
    'expected_at',
  ],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceServiceNotAsDescribed: [
    'canceled_at',
    'received_at',
  ],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceServiceNotAsDescribedCanceledAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceServiceNotAsDescribedMaybeEmpty: [
    'canceled_at',
    'received_at',
  ],
  OpenapiPostV1IssuingDisputesDisputeInputEvidenceServiceNotAsDescribedReceivedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeInputMetadataMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesDisputeSubmitInput: [
    'metadata',
  ],
  OpenapiPostV1IssuingDisputesDisputeSubmitInputMetadataMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInput: [
    'evidence.canceled',
    'evidence.canceled.canceled_at',
    'evidence.canceled.cancellation_policy_provided',
    'evidence.canceled.expected_at',
    'evidence.canceled.returned_at',
    'evidence.duplicate',
    'evidence.fraudulent',
    'evidence.merchandise_not_as_described',
    'evidence.merchandise_not_as_described.received_at',
    'evidence.merchandise_not_as_described.returned_at',
    'evidence.no_valid_authorization',
    'evidence.not_received',
    'evidence.not_received.expected_at',
    'evidence.other',
    'evidence.product_not_received',
    'evidence.product_not_received.expected_at',
    'evidence.service_not_as_described',
    'evidence.service_not_as_described.canceled_at',
    'evidence.service_not_as_described.received_at',
  ],
  OpenapiPostV1IssuingDisputesInputEvidence: [
    'canceled',
    'canceled.canceled_at',
    'canceled.cancellation_policy_provided',
    'canceled.expected_at',
    'canceled.returned_at',
    'duplicate',
    'fraudulent',
    'merchandise_not_as_described',
    'merchandise_not_as_described.received_at',
    'merchandise_not_as_described.returned_at',
    'no_valid_authorization',
    'not_received',
    'not_received.expected_at',
    'other',
    'product_not_received',
    'product_not_received.expected_at',
    'service_not_as_described',
    'service_not_as_described.canceled_at',
    'service_not_as_described.received_at',
  ],
  OpenapiPostV1IssuingDisputesInputEvidenceCanceled: [
    'canceled_at',
    'cancellation_policy_provided',
    'expected_at',
    'returned_at',
  ],
  OpenapiPostV1IssuingDisputesInputEvidenceCanceledCanceledAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceCanceledCancellationPolicyProvidedMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceCanceledExpectedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceCanceledMaybeEmpty: [
    'canceled_at',
    'cancellation_policy_provided',
    'expected_at',
    'returned_at',
  ],
  OpenapiPostV1IssuingDisputesInputEvidenceCanceledReturnedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceDuplicateMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceFraudulentMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceMerchandiseNotAsDescribed: [
    'received_at',
    'returned_at',
  ],
  OpenapiPostV1IssuingDisputesInputEvidenceMerchandiseNotAsDescribedMaybeEmpty: [
    'received_at',
    'returned_at',
  ],
  OpenapiPostV1IssuingDisputesInputEvidenceMerchandiseNotAsDescribedReceivedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceMerchandiseNotAsDescribedReturnedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceNoValidAuthorizationMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceNotReceived: [
    'expected_at',
  ],
  OpenapiPostV1IssuingDisputesInputEvidenceNotReceivedExpectedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceNotReceivedMaybeEmpty: [
    'expected_at',
  ],
  OpenapiPostV1IssuingDisputesInputEvidenceOtherMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceProductNotReceived: [
    'expected_at',
  ],
  OpenapiPostV1IssuingDisputesInputEvidenceProductNotReceivedExpectedAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceProductNotReceivedMaybeEmpty: [
    'expected_at',
  ],
  OpenapiPostV1IssuingDisputesInputEvidenceServiceNotAsDescribed: [
    'canceled_at',
    'received_at',
  ],
  OpenapiPostV1IssuingDisputesInputEvidenceServiceNotAsDescribedCanceledAtMaybeEmpty: [],
  OpenapiPostV1IssuingDisputesInputEvidenceServiceNotAsDescribedMaybeEmpty: [
    'canceled_at',
    'received_at',
  ],
  OpenapiPostV1IssuingDisputesInputEvidenceServiceNotAsDescribedReceivedAtMaybeEmpty: [],
  OpenapiPostV1IssuingPersonalizationDesignsPersonalizationDesignInput: [
    'carrier_text',
  ],
  OpenapiPostV1IssuingPersonalizationDesignsPersonalizationDesignInputCarrierTextMaybeEmpty: [],
  OpenapiPostV1IssuingProgramsProgramInput: [
    'metadata',
  ],
  OpenapiPostV1IssuingProgramsProgramInputMetadataMaybeEmpty: [],
  OpenapiPostV1IssuingTransactionsTransactionInput: [
    'metadata',
  ],
  OpenapiPostV1IssuingTransactionsTransactionInputMetadataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInput: [
    'amount_details.discount_amount',
    'amount_details.donation',
    'amount_details.line_items',
    'amount_details.shipping',
    'amount_details.shipping.amount',
    'amount_details.surcharge',
    'amount_details.surcharge.amount',
    'amount_details.tax',
    'level3',
    'mandate_data',
    'payment_details.benefit.fr_meal_voucher',
    'payment_details.car_rental_data',
    'payment_details.flight_data',
    'payment_details.lodging_data',
    'payment_method_data.billing_details.address',
    'payment_method_options.acss_debit',
    'payment_method_options.affirm',
    'payment_method_options.afterpay_clearpay',
    'payment_method_options.alipay',
    'payment_method_options.alma',
    'payment_method_options.amazon_pay',
    'payment_method_options.au_becs_debit',
    'payment_method_options.bacs_debit',
    'payment_method_options.bancontact',
    'payment_method_options.billie',
    'payment_method_options.billie.company_details',
    'payment_method_options.billie.company_details.registered_address',
    'payment_method_options.bizum',
    'payment_method_options.blik',
    'payment_method_options.boleto',
    'payment_method_options.card',
    'payment_method_options.card.buy_now_pay_later_options',
    'payment_method_options.card.installments.plan',
    'payment_method_options.card.recipient_details',
    'payment_method_options.card.sender_details',
    'payment_method_options.card.statement_details',
    'payment_method_options.card_present',
    'payment_method_options.card_present.buy_now_pay_later_options',
    'payment_method_options.card_present.recipient_details',
    'payment_method_options.card_present.sender_details',
    'payment_method_options.cashapp',
    'payment_method_options.click_to_pay',
    'payment_method_options.crypto',
    'payment_method_options.customer_balance',
    'payment_method_options.demo_pay',
    'payment_method_options.dummy_auth_push',
    'payment_method_options.dummy_passthrough_card',
    'payment_method_options.eps',
    'payment_method_options.fpx',
    'payment_method_options.getbalance',
    'payment_method_options.giropay',
    'payment_method_options.gopay',
    'payment_method_options.grabpay',
    'payment_method_options.id_bank_transfer',
    'payment_method_options.ideal',
    'payment_method_options.interac_present',
    'payment_method_options.kakao_pay',
    'payment_method_options.klarna',
    'payment_method_options.klarna.line_items',
    'payment_method_options.klarna.subscriptions',
    'payment_method_options.klarna.supplementary_purchase_data',
    'payment_method_options.klarna.supplementary_purchase_data.bus_reservation_details',
    'payment_method_options.klarna.supplementary_purchase_data.customer',
    'payment_method_options.klarna.supplementary_purchase_data.event_reservation_details',
    'payment_method_options.klarna.supplementary_purchase_data.ferry_reservation_details',
    'payment_method_options.klarna.supplementary_purchase_data.insurances',
    'payment_method_options.klarna.supplementary_purchase_data.marketplace_sellers',
    'payment_method_options.klarna.supplementary_purchase_data.round_trip_reservation_details',
    'payment_method_options.klarna.supplementary_purchase_data.train_reservation_details',
    'payment_method_options.klarna.supplementary_purchase_data.vouchers',
    'payment_method_options.knet',
    'payment_method_options.konbini',
    'payment_method_options.konbini.expires_after_days',
    'payment_method_options.konbini.expires_at',
    'payment_method_options.konbini.fee_amount',
    'payment_method_options.konbini.tax_amount',
    'payment_method_options.kr_card',
    'payment_method_options.kr_market',
    'payment_method_options.link',
    'payment_method_options.link.instant_debits.sellers',
    'payment_method_options.mb_way',
    'payment_method_options.mobilepay',
    'payment_method_options.mondu',
    'payment_method_options.multibanco',
    'payment_method_options.naver_pay',
    'payment_method_options.ng_bank',
    'payment_method_options.ng_bank_transfer',
    'payment_method_options.ng_card',
    'payment_method_options.ng_market',
    'payment_method_options.ng_ussd',
    'payment_method_options.nz_bank_account',
    'payment_method_options.oxxo',
    'payment_method_options.p24',
    'payment_method_options.pay_by_bank',
    'payment_method_options.payco',
    'payment_method_options.paynow',
    'payment_method_options.paypal',
    'payment_method_options.paypay',
    'payment_method_options.payto',
    'payment_method_options.payto.mandate_options.amount',
    'payment_method_options.payto.mandate_options.payments_per_period',
    'payment_method_options.pix',
    'payment_method_options.promptpay',
    'payment_method_options.qris',
    'payment_method_options.rechnung',
    'payment_method_options.revolut_pay',
    'payment_method_options.samsung_pay',
    'payment_method_options.satispay',
    'payment_method_options.scalapay',
    'payment_method_options.sepa_debit',
    'payment_method_options.shopeepay',
    'payment_method_options.sofort',
    'payment_method_options.stripe_balance',
    'payment_method_options.swish',
    'payment_method_options.twint',
    'payment_method_options.upi',
    'payment_method_options.us_bank_account',
    'payment_method_options.vipps',
    'payment_method_options.wechat_pay',
    'payment_method_options.zip',
    'source_data.mandate.amount',
    'transfer_data.metadata',
    'transfer_data.payment_data.metadata',
  ],
  OpenapiPostV1PaymentIntentsInputAmountDetails: [
    'discount_amount',
    'donation',
    'line_items',
    'shipping',
    'shipping.amount',
    'surcharge',
    'surcharge.amount',
    'tax',
  ],
  OpenapiPostV1PaymentIntentsInputAmountDetailsDiscountAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputAmountDetailsDonationMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputAmountDetailsLineItemsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputAmountDetailsShipping: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsInputAmountDetailsShippingAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputAmountDetailsShippingMaybeEmpty: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsInputAmountDetailsSurcharge: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsInputAmountDetailsSurchargeAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputAmountDetailsSurchargeMaybeEmpty: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsInputAmountDetailsTaxMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputLevel3MaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputMandateDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentDetails: [
    'benefit.fr_meal_voucher',
    'car_rental_data',
    'flight_data',
    'lodging_data',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentDetailsBenefit: [
    'fr_meal_voucher',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentDetailsBenefitFrMealVoucherMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentDetailsCarRentalDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentDetailsFlightDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentDetailsLodgingDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodData: [
    'billing_details.address',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodDataBillingDetails: [
    'address',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodDataBillingDetailsAddressMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptions: [
    'acss_debit',
    'affirm',
    'afterpay_clearpay',
    'alipay',
    'alma',
    'amazon_pay',
    'au_becs_debit',
    'bacs_debit',
    'bancontact',
    'billie',
    'billie.company_details',
    'billie.company_details.registered_address',
    'bizum',
    'blik',
    'boleto',
    'card',
    'card.buy_now_pay_later_options',
    'card.installments.plan',
    'card.recipient_details',
    'card.sender_details',
    'card.statement_details',
    'card_present',
    'card_present.buy_now_pay_later_options',
    'card_present.recipient_details',
    'card_present.sender_details',
    'cashapp',
    'click_to_pay',
    'crypto',
    'customer_balance',
    'demo_pay',
    'dummy_auth_push',
    'dummy_passthrough_card',
    'eps',
    'fpx',
    'getbalance',
    'giropay',
    'gopay',
    'grabpay',
    'id_bank_transfer',
    'ideal',
    'interac_present',
    'kakao_pay',
    'klarna',
    'klarna.line_items',
    'klarna.subscriptions',
    'klarna.supplementary_purchase_data',
    'klarna.supplementary_purchase_data.bus_reservation_details',
    'klarna.supplementary_purchase_data.customer',
    'klarna.supplementary_purchase_data.event_reservation_details',
    'klarna.supplementary_purchase_data.ferry_reservation_details',
    'klarna.supplementary_purchase_data.insurances',
    'klarna.supplementary_purchase_data.marketplace_sellers',
    'klarna.supplementary_purchase_data.round_trip_reservation_details',
    'klarna.supplementary_purchase_data.train_reservation_details',
    'klarna.supplementary_purchase_data.vouchers',
    'knet',
    'konbini',
    'konbini.expires_after_days',
    'konbini.expires_at',
    'konbini.fee_amount',
    'konbini.tax_amount',
    'kr_card',
    'kr_market',
    'link',
    'link.instant_debits.sellers',
    'mb_way',
    'mobilepay',
    'mondu',
    'multibanco',
    'naver_pay',
    'ng_bank',
    'ng_bank_transfer',
    'ng_card',
    'ng_market',
    'ng_ussd',
    'nz_bank_account',
    'oxxo',
    'p24',
    'pay_by_bank',
    'payco',
    'paynow',
    'paypal',
    'paypay',
    'payto',
    'payto.mandate_options.amount',
    'payto.mandate_options.payments_per_period',
    'pix',
    'promptpay',
    'qris',
    'rechnung',
    'revolut_pay',
    'samsung_pay',
    'satispay',
    'scalapay',
    'sepa_debit',
    'shopeepay',
    'sofort',
    'stripe_balance',
    'swish',
    'twint',
    'upi',
    'us_bank_account',
    'vipps',
    'wechat_pay',
    'zip',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsAcssDebitMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsAffirmMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsAfterpayClearpayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsAlipayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsAlmaMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsAmazonPayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsAuBecsDebitMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsBacsDebitMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsBancontactMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsBillie: [
    'company_details',
    'company_details.registered_address',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsBillieCompanyDetails: [
    'registered_address',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsBillieCompanyDetailsMaybeEmpty: [
    'registered_address',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsBillieCompanyDetailsRegisteredAddressMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsBillieMaybeEmpty: [
    'company_details',
    'company_details.registered_address',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsBizumMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsBlikMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsBoletoMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCard: [
    'buy_now_pay_later_options',
    'installments.plan',
    'recipient_details',
    'sender_details',
    'statement_details',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCardBuyNowPayLaterOptionsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCardInstallments: [
    'plan',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCardInstallmentsPlanMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCardMaybeEmpty: [
    'buy_now_pay_later_options',
    'installments.plan',
    'recipient_details',
    'sender_details',
    'statement_details',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCardPresent: [
    'buy_now_pay_later_options',
    'recipient_details',
    'sender_details',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCardPresentBuyNowPayLaterOptionsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCardPresentMaybeEmpty: [
    'buy_now_pay_later_options',
    'recipient_details',
    'sender_details',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCardPresentRecipientDetailsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCardPresentSenderDetailsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCardRecipientDetailsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCardSenderDetailsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCardStatementDetailsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCashappMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsClickToPayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCryptoMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsCustomerBalanceMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsDemoPayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsDummyAuthPushMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsDummyPassthroughCardMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsEpsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsFpxMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsGetbalanceMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsGiropayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsGopayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsGrabpayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsIdBankTransferMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsIdealMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsInteracPresentMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKakaoPayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarna: [
    'line_items',
    'subscriptions',
    'supplementary_purchase_data',
    'supplementary_purchase_data.bus_reservation_details',
    'supplementary_purchase_data.customer',
    'supplementary_purchase_data.event_reservation_details',
    'supplementary_purchase_data.ferry_reservation_details',
    'supplementary_purchase_data.insurances',
    'supplementary_purchase_data.marketplace_sellers',
    'supplementary_purchase_data.round_trip_reservation_details',
    'supplementary_purchase_data.train_reservation_details',
    'supplementary_purchase_data.vouchers',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaLineItemsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaMaybeEmpty: [
    'line_items',
    'subscriptions',
    'supplementary_purchase_data',
    'supplementary_purchase_data.bus_reservation_details',
    'supplementary_purchase_data.customer',
    'supplementary_purchase_data.event_reservation_details',
    'supplementary_purchase_data.ferry_reservation_details',
    'supplementary_purchase_data.insurances',
    'supplementary_purchase_data.marketplace_sellers',
    'supplementary_purchase_data.round_trip_reservation_details',
    'supplementary_purchase_data.train_reservation_details',
    'supplementary_purchase_data.vouchers',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaSubscriptionsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseData: [
    'bus_reservation_details',
    'customer',
    'event_reservation_details',
    'ferry_reservation_details',
    'insurances',
    'marketplace_sellers',
    'round_trip_reservation_details',
    'train_reservation_details',
    'vouchers',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataBusReservationDetailsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataCustomerMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataEventReservationDetailsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataFerryReservationDetailsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataInsurancesMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataMarketplaceSellersMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataMaybeEmpty: [
    'bus_reservation_details',
    'customer',
    'event_reservation_details',
    'ferry_reservation_details',
    'insurances',
    'marketplace_sellers',
    'round_trip_reservation_details',
    'train_reservation_details',
    'vouchers',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataRoundTripReservationDetailsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataTrainReservationDetailsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataVouchersMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKnetMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKonbini: [
    'expires_after_days',
    'expires_at',
    'fee_amount',
    'tax_amount',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKonbiniExpiresAfterDaysMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKonbiniExpiresAtMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKonbiniFeeAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKonbiniMaybeEmpty: [
    'expires_after_days',
    'expires_at',
    'fee_amount',
    'tax_amount',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKonbiniTaxAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKrCardMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsKrMarketMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsLink: [
    'instant_debits.sellers',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsLinkInstantDebits: [
    'sellers',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsLinkInstantDebitsSellersMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsLinkMaybeEmpty: [
    'instant_debits.sellers',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsMbWayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsMobilepayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsMonduMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsMultibancoMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsNaverPayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsNgBankMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsNgBankTransferMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsNgCardMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsNgMarketMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsNgUssdMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsNzBankAccountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsOxxoMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsP24MaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsPayByBankMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsPaycoMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsPaynowMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsPaypalMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsPaypayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsPayto: [
    'mandate_options.amount',
    'mandate_options.payments_per_period',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsPaytoMandateOptions: [
    'amount',
    'payments_per_period',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsPaytoMandateOptionsAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsPaytoMandateOptionsPaymentsPerPeriodMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsPaytoMaybeEmpty: [
    'mandate_options.amount',
    'mandate_options.payments_per_period',
  ],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsPixMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsPromptpayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsQrisMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsRechnungMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsRevolutPayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsSamsungPayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsSatispayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsScalapayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsSepaDebitMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsShopeepayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsSofortMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsStripeBalanceMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsSwishMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsTwintMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsUpiMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsVippsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsWechatPayMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputPaymentMethodOptionsZipMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputSourceData: [
    'mandate.amount',
  ],
  OpenapiPostV1PaymentIntentsInputSourceDataMandate: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsInputSourceDataMandateAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputTransferData: [
    'metadata',
    'payment_data.metadata',
  ],
  OpenapiPostV1PaymentIntentsInputTransferDataMetadataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsInputTransferDataPaymentData: [
    'metadata',
  ],
  OpenapiPostV1PaymentIntentsInputTransferDataPaymentDataMetadataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentCaptureInput: [
    'amount_details.discount_amount',
    'amount_details.donation',
    'amount_details.line_items',
    'amount_details.shipping',
    'amount_details.shipping.amount',
    'amount_details.surcharge',
    'amount_details.surcharge.amount',
    'amount_details.tax',
    'level3',
    'metadata',
    'payment_details',
    'payment_details.car_rental_data',
    'payment_details.flight_data',
    'payment_details.lodging_data',
  ],
  OpenapiPostV1PaymentIntentsIntentCaptureInputAmountDetails: [
    'discount_amount',
    'donation',
    'line_items',
    'shipping',
    'shipping.amount',
    'surcharge',
    'surcharge.amount',
    'tax',
  ],
  OpenapiPostV1PaymentIntentsIntentCaptureInputAmountDetailsDiscountAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentCaptureInputAmountDetailsDonationMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentCaptureInputAmountDetailsLineItemsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentCaptureInputAmountDetailsShipping: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentCaptureInputAmountDetailsShippingAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentCaptureInputAmountDetailsShippingMaybeEmpty: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentCaptureInputAmountDetailsSurcharge: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentCaptureInputAmountDetailsSurchargeAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentCaptureInputAmountDetailsSurchargeMaybeEmpty: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentCaptureInputAmountDetailsTaxMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentCaptureInputLevel3MaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentCaptureInputMetadataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentCaptureInputPaymentDetails: [
    'car_rental_data',
    'flight_data',
    'lodging_data',
  ],
  OpenapiPostV1PaymentIntentsIntentCaptureInputPaymentDetailsCarRentalDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentCaptureInputPaymentDetailsFlightDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentCaptureInputPaymentDetailsLodgingDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentCaptureInputPaymentDetailsMaybeEmpty: [
    'car_rental_data',
    'flight_data',
    'lodging_data',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInput: [
    'amount_details',
    'amount_details.discount_amount',
    'amount_details.donation',
    'amount_details.line_items',
    'amount_details.shipping',
    'amount_details.shipping.amount',
    'amount_details.surcharge',
    'amount_details.surcharge.amount',
    'amount_details.tax',
    'application_fee_amount',
    'excluded_payment_method_types',
    'level3',
    'payment_details',
    'payment_details.benefit.fr_meal_voucher',
    'payment_details.car_rental_data',
    'payment_details.flight_data',
    'payment_details.lodging_data',
    'payment_method_data.billing_details.address',
    'redirect_preferences.additional_formats',
    'shipping',
    'source_data.mandate.amount',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputAmountDetails: [
    'discount_amount',
    'donation',
    'line_items',
    'shipping',
    'shipping.amount',
    'surcharge',
    'surcharge.amount',
    'tax',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputAmountDetailsDiscountAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputAmountDetailsDonationMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputAmountDetailsLineItemsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputAmountDetailsMaybeEmpty: [
    'discount_amount',
    'donation',
    'line_items',
    'shipping',
    'shipping.amount',
    'surcharge',
    'surcharge.amount',
    'tax',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputAmountDetailsShipping: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputAmountDetailsShippingAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputAmountDetailsShippingMaybeEmpty: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputAmountDetailsSurcharge: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputAmountDetailsSurchargeAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputAmountDetailsSurchargeMaybeEmpty: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputAmountDetailsTaxMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputApplicationFeeAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputExcludedPaymentMethodTypesMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputLevel3MaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputPaymentDetails: [
    'benefit.fr_meal_voucher',
    'car_rental_data',
    'flight_data',
    'lodging_data',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputPaymentDetailsBenefit: [
    'fr_meal_voucher',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputPaymentDetailsBenefitFrMealVoucherMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputPaymentDetailsCarRentalDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputPaymentDetailsFlightDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputPaymentDetailsLodgingDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputPaymentDetailsMaybeEmpty: [
    'benefit.fr_meal_voucher',
    'car_rental_data',
    'flight_data',
    'lodging_data',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputPaymentMethodData: [
    'billing_details.address',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputPaymentMethodDataBillingDetails: [
    'address',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputPaymentMethodDataBillingDetailsAddressMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputRedirectPreferences: [
    'additional_formats',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputRedirectPreferencesAdditionalFormatsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputShippingMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentConfirmInputSourceData: [
    'mandate.amount',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputSourceDataMandate: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentConfirmInputSourceDataMandateAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInput: [
    'amount_details',
    'amount_details.discount_amount',
    'amount_details.donation',
    'amount_details.line_items',
    'amount_details.shipping',
    'amount_details.shipping.amount',
    'amount_details.surcharge',
    'amount_details.surcharge.amount',
    'amount_details.tax',
    'application_fee_amount',
    'excluded_payment_method_types',
    'level3',
    'metadata',
    'payment_details',
    'payment_details.benefit.fr_meal_voucher',
    'payment_details.car_rental_data',
    'payment_details.flight_data',
    'payment_details.lodging_data',
    'payment_method_data.billing_details.address',
    'shipping',
    'source_data.mandate.amount',
    'transfer_data.metadata',
    'transfer_data.payment_data.metadata',
  ],
  OpenapiPostV1PaymentIntentsIntentInputAmountDetails: [
    'discount_amount',
    'donation',
    'line_items',
    'shipping',
    'shipping.amount',
    'surcharge',
    'surcharge.amount',
    'tax',
  ],
  OpenapiPostV1PaymentIntentsIntentInputAmountDetailsDiscountAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputAmountDetailsDonationMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputAmountDetailsLineItemsMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputAmountDetailsMaybeEmpty: [
    'discount_amount',
    'donation',
    'line_items',
    'shipping',
    'shipping.amount',
    'surcharge',
    'surcharge.amount',
    'tax',
  ],
  OpenapiPostV1PaymentIntentsIntentInputAmountDetailsShipping: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentInputAmountDetailsShippingAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputAmountDetailsShippingMaybeEmpty: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentInputAmountDetailsSurcharge: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentInputAmountDetailsSurchargeAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputAmountDetailsSurchargeMaybeEmpty: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentInputAmountDetailsTaxMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputApplicationFeeAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputExcludedPaymentMethodTypesMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputLevel3MaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputMetadataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputPaymentDetails: [
    'benefit.fr_meal_voucher',
    'car_rental_data',
    'flight_data',
    'lodging_data',
  ],
  OpenapiPostV1PaymentIntentsIntentInputPaymentDetailsBenefit: [
    'fr_meal_voucher',
  ],
  OpenapiPostV1PaymentIntentsIntentInputPaymentDetailsBenefitFrMealVoucherMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputPaymentDetailsCarRentalDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputPaymentDetailsFlightDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputPaymentDetailsLodgingDataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputPaymentDetailsMaybeEmpty: [
    'benefit.fr_meal_voucher',
    'car_rental_data',
    'flight_data',
    'lodging_data',
  ],
  OpenapiPostV1PaymentIntentsIntentInputPaymentMethodData: [
    'billing_details.address',
  ],
  OpenapiPostV1PaymentIntentsIntentInputPaymentMethodDataBillingDetails: [
    'address',
  ],
  OpenapiPostV1PaymentIntentsIntentInputPaymentMethodDataBillingDetailsAddressMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputShippingMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputSourceData: [
    'mandate.amount',
  ],
  OpenapiPostV1PaymentIntentsIntentInputSourceDataMandate: [
    'amount',
  ],
  OpenapiPostV1PaymentIntentsIntentInputSourceDataMandateAmountMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputTransferData: [
    'metadata',
    'payment_data.metadata',
  ],
  OpenapiPostV1PaymentIntentsIntentInputTransferDataMetadataMaybeEmpty: [],
  OpenapiPostV1PaymentIntentsIntentInputTransferDataPaymentData: [
    'metadata',
  ],
  OpenapiPostV1PaymentIntentsIntentInputTransferDataPaymentDataMetadataMaybeEmpty: [],
  OpenapiPostV1PaymentLinksInput: [
    'custom_text.after_submit',
    'custom_text.shipping_address',
    'custom_text.submit',
    'custom_text.terms_of_service_acceptance',
    'invoice_creation.invoice_data.account_tax_ids',
    'invoice_creation.invoice_data.custom_fields',
    'invoice_creation.invoice_data.metadata',
    'invoice_creation.invoice_data.rendering_options',
  ],
  OpenapiPostV1PaymentLinksInputCustomText: [
    'after_submit',
    'shipping_address',
    'submit',
    'terms_of_service_acceptance',
  ],
  OpenapiPostV1PaymentLinksInputCustomTextAfterSubmitMaybeEmpty: [],
  OpenapiPostV1PaymentLinksInputCustomTextShippingAddressMaybeEmpty: [],
  OpenapiPostV1PaymentLinksInputCustomTextSubmitMaybeEmpty: [],
  OpenapiPostV1PaymentLinksInputCustomTextTermsOfServiceAcceptanceMaybeEmpty: [],
  OpenapiPostV1PaymentLinksInputInvoiceCreation: [
    'invoice_data.account_tax_ids',
    'invoice_data.custom_fields',
    'invoice_data.metadata',
    'invoice_data.rendering_options',
  ],
  OpenapiPostV1PaymentLinksInputInvoiceCreationInvoiceData: [
    'account_tax_ids',
    'custom_fields',
    'metadata',
    'rendering_options',
  ],
  OpenapiPostV1PaymentLinksInputInvoiceCreationInvoiceDataAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1PaymentLinksInputInvoiceCreationInvoiceDataCustomFieldsMaybeEmpty: [],
  OpenapiPostV1PaymentLinksInputInvoiceCreationInvoiceDataMetadataMaybeEmpty: [],
  OpenapiPostV1PaymentLinksInputInvoiceCreationInvoiceDataRenderingOptionsMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInput: [
    'application_fee_amount',
    'application_fee_percent',
    'custom_fields',
    'custom_text.after_submit',
    'custom_text.shipping_address',
    'custom_text.submit',
    'custom_text.terms_of_service_acceptance',
    'invoice_creation.invoice_data.account_tax_ids',
    'invoice_creation.invoice_data.custom_fields',
    'invoice_creation.invoice_data.metadata',
    'invoice_creation.invoice_data.rendering_options',
    'name_collection',
    'optional_items',
    'payment_intent_data.metadata',
    'payment_method_options',
    'payment_method_options.card',
    'payment_method_options.card.restrictions',
    'payment_method_options.card.restrictions.brands_blocked',
    'payment_method_types',
    'restrictions',
    'shipping_address_collection',
    'shipping_options',
    'subscription_data.metadata',
    'subscription_data.trial_period_days',
    'subscription_data.trial_settings',
    'transfer_data',
    'transfer_data.amount',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputApplicationFeeAmountMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputApplicationFeePercentMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputCustomFieldsMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputCustomText: [
    'after_submit',
    'shipping_address',
    'submit',
    'terms_of_service_acceptance',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputCustomTextAfterSubmitMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputCustomTextShippingAddressMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputCustomTextSubmitMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputCustomTextTermsOfServiceAcceptanceMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputInvoiceCreation: [
    'invoice_data.account_tax_ids',
    'invoice_data.custom_fields',
    'invoice_data.metadata',
    'invoice_data.rendering_options',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputInvoiceCreationInvoiceData: [
    'account_tax_ids',
    'custom_fields',
    'metadata',
    'rendering_options',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputInvoiceCreationInvoiceDataAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputInvoiceCreationInvoiceDataCustomFieldsMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputInvoiceCreationInvoiceDataMetadataMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputInvoiceCreationInvoiceDataRenderingOptionsMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputNameCollectionMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputOptionalItemsMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputPaymentIntentData: [
    'metadata',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputPaymentIntentDataMetadataMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputPaymentMethodOptions: [
    'card',
    'card.restrictions',
    'card.restrictions.brands_blocked',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputPaymentMethodOptionsCard: [
    'restrictions',
    'restrictions.brands_blocked',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputPaymentMethodOptionsCardMaybeEmpty: [
    'restrictions',
    'restrictions.brands_blocked',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputPaymentMethodOptionsCardRestrictions: [
    'brands_blocked',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputPaymentMethodOptionsCardRestrictionsBrandsBlockedMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputPaymentMethodOptionsCardRestrictionsMaybeEmpty: [
    'brands_blocked',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputPaymentMethodOptionsMaybeEmpty: [
    'card',
    'card.restrictions',
    'card.restrictions.brands_blocked',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputPaymentMethodTypesMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputRestrictionsMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputShippingAddressCollectionMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputShippingOptionsMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputSubscriptionData: [
    'metadata',
    'trial_period_days',
    'trial_settings',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputSubscriptionDataMetadataMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputSubscriptionDataTrialPeriodDaysMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputSubscriptionDataTrialSettingsMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputTransferData: [
    'amount',
  ],
  OpenapiPostV1PaymentLinksPaymentLinkInputTransferDataAmountMaybeEmpty: [],
  OpenapiPostV1PaymentLinksPaymentLinkInputTransferDataMaybeEmpty: [
    'amount',
  ],
  OpenapiPostV1PaymentMethodsInput: [
    'billing_details.address',
  ],
  OpenapiPostV1PaymentMethodsInputBillingDetails: [
    'address',
  ],
  OpenapiPostV1PaymentMethodsInputBillingDetailsAddressMaybeEmpty: [],
  OpenapiPostV1PaymentMethodsPaymentMethodInput: [
    'billing_details.address',
    'card.token_revoked_at',
    'metadata',
  ],
  OpenapiPostV1PaymentMethodsPaymentMethodInputBillingDetails: [
    'address',
  ],
  OpenapiPostV1PaymentMethodsPaymentMethodInputBillingDetailsAddressMaybeEmpty: [],
  OpenapiPostV1PaymentMethodsPaymentMethodInputCard: [
    'token_revoked_at',
  ],
  OpenapiPostV1PaymentMethodsPaymentMethodInputCardTokenRevokedAtMaybeEmpty: [],
  OpenapiPostV1PaymentMethodsPaymentMethodInputMetadataMaybeEmpty: [],
  OpenapiPostV1PaymentRecordsReportPaymentInput: [
    'metadata',
  ],
  OpenapiPostV1PaymentRecordsReportPaymentInputMetadataMaybeEmpty: [],
  OpenapiPostV1PayoutsPayoutInput: [
    'metadata',
  ],
  OpenapiPostV1PayoutsPayoutInputMetadataMaybeEmpty: [],
  OpenapiPostV1PricesPriceInput: [
    'currency_options',
    'custom_unit_amount',
    'metadata',
    'migrate_to',
    'recurring',
    'tiers',
    'transform_quantity',
  ],
  OpenapiPostV1PricesPriceInputCurrencyOptionsMaybeEmpty: [],
  OpenapiPostV1PricesPriceInputCustomUnitAmountMaybeEmpty: [],
  OpenapiPostV1PricesPriceInputMetadataMaybeEmpty: [],
  OpenapiPostV1PricesPriceInputMigrateToMaybeEmpty: [],
  OpenapiPostV1PricesPriceInputRecurringMaybeEmpty: [],
  OpenapiPostV1PricesPriceInputTiersMaybeEmpty: [],
  OpenapiPostV1PricesPriceInputTransformQuantityMaybeEmpty: [],
  OpenapiPostV1PricingTablesPricingTableInput: [
    'custom_url_item_data',
  ],
  OpenapiPostV1PricingTablesPricingTableInputCustomUrlItemDataMaybeEmpty: [],
  OpenapiPostV1ProductClassesIdInput: [
    'images',
    'metadata',
  ],
  OpenapiPostV1ProductClassesIdInputImagesMaybeEmpty: [],
  OpenapiPostV1ProductClassesIdInputMetadataMaybeEmpty: [],
  OpenapiPostV1ProductsIdInput: [
    'addons',
    'attribute_values',
    'attributes',
    'cross_sells',
    'images',
    'marketing_features',
    'metadata',
    'package_dimensions',
    'price_options',
    'tax_details',
  ],
  OpenapiPostV1ProductsIdInputAddonsMaybeEmpty: [],
  OpenapiPostV1ProductsIdInputAttributeValuesMaybeEmpty: [],
  OpenapiPostV1ProductsIdInputAttributesMaybeEmpty: [],
  OpenapiPostV1ProductsIdInputCrossSellsMaybeEmpty: [],
  OpenapiPostV1ProductsIdInputImagesMaybeEmpty: [],
  OpenapiPostV1ProductsIdInputMarketingFeaturesMaybeEmpty: [],
  OpenapiPostV1ProductsIdInputMetadataMaybeEmpty: [],
  OpenapiPostV1ProductsIdInputPackageDimensionsMaybeEmpty: [],
  OpenapiPostV1ProductsIdInputPriceOptionsMaybeEmpty: [],
  OpenapiPostV1ProductsIdInputTaxDetailsMaybeEmpty: [],
  OpenapiPostV1ProfilesInput: [
    'metadata',
  ],
  OpenapiPostV1ProfilesInputMetadataMaybeEmpty: [],
  OpenapiPostV1ProfilesNetworkIdInput: [
    'new_metadata',
  ],
  OpenapiPostV1ProfilesNetworkIdInputNewMetadataMaybeEmpty: [],
  OpenapiPostV1QuotesInput: [
    'application_fee_amount',
    'application_fee_percent',
    'default_tax_rates',
    'discounts',
    'invoice_settings.custom_fields',
    'line_items.discounts',
    'line_items.tax_rates',
    'lines.actions.set_metadata',
    'subscription_data.prebilling',
    'subscription_data.trial_period_days',
    'transfer_data',
  ],
  OpenapiPostV1QuotesInputApplicationFeeAmountMaybeEmpty: [],
  OpenapiPostV1QuotesInputApplicationFeePercentMaybeEmpty: [],
  OpenapiPostV1QuotesInputDefaultTaxRatesMaybeEmpty: [],
  OpenapiPostV1QuotesInputDiscountsMaybeEmpty: [],
  OpenapiPostV1QuotesInputInvoiceSettings: [
    'custom_fields',
  ],
  OpenapiPostV1QuotesInputInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1QuotesInputLineItems: [
    'discounts',
    'tax_rates',
  ],
  OpenapiPostV1QuotesInputLineItemsDiscountsMaybeEmpty: [],
  OpenapiPostV1QuotesInputLineItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1QuotesInputLines: [
    'actions.set_metadata',
  ],
  OpenapiPostV1QuotesInputLinesActions: [
    'set_metadata',
  ],
  OpenapiPostV1QuotesInputLinesActionsSetMetadataMaybeEmpty: [],
  OpenapiPostV1QuotesInputSubscriptionData: [
    'prebilling',
    'trial_period_days',
  ],
  OpenapiPostV1QuotesInputSubscriptionDataPrebillingMaybeEmpty: [],
  OpenapiPostV1QuotesInputSubscriptionDataTrialPeriodDaysMaybeEmpty: [],
  OpenapiPostV1QuotesInputTransferDataMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInput: [
    'application_fee_amount',
    'application_fee_percent',
    'default_tax_rates',
    'discounts',
    'invoice_settings.custom_fields',
    'line_items.discounts',
    'line_items.tax_rates',
    'lines.actions.set_metadata',
    'subscription_data.bill_on_acceptance',
    'subscription_data.billing_schedules',
    'subscription_data.prebilling',
    'subscription_data.trial_period_days',
    'subscription_data_overrides',
    'subscription_data_overrides.bill_on_acceptance',
    'transfer_data',
  ],
  OpenapiPostV1QuotesQuoteInputApplicationFeeAmountMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputApplicationFeePercentMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputDefaultTaxRatesMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputDiscountsMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputInvoiceSettings: [
    'custom_fields',
  ],
  OpenapiPostV1QuotesQuoteInputInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputLineItems: [
    'discounts',
    'tax_rates',
  ],
  OpenapiPostV1QuotesQuoteInputLineItemsDiscountsMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputLineItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputLines: [
    'actions.set_metadata',
  ],
  OpenapiPostV1QuotesQuoteInputLinesActions: [
    'set_metadata',
  ],
  OpenapiPostV1QuotesQuoteInputLinesActionsSetMetadataMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputSubscriptionData: [
    'bill_on_acceptance',
    'billing_schedules',
    'prebilling',
    'trial_period_days',
  ],
  OpenapiPostV1QuotesQuoteInputSubscriptionDataBillOnAcceptanceMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputSubscriptionDataBillingSchedulesMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputSubscriptionDataOverrides: [
    'bill_on_acceptance',
  ],
  OpenapiPostV1QuotesQuoteInputSubscriptionDataOverridesBillOnAcceptanceMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputSubscriptionDataOverridesMaybeEmpty: [
    'bill_on_acceptance',
  ],
  OpenapiPostV1QuotesQuoteInputSubscriptionDataPrebillingMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputSubscriptionDataTrialPeriodDaysMaybeEmpty: [],
  OpenapiPostV1QuotesQuoteInputTransferDataMaybeEmpty: [],
  OpenapiPostV1RefundsInput: [
    'metadata',
    'payment_method_data.billing_details.address',
    'payment_method_options.acss_debit',
    'payment_method_options.affirm',
    'payment_method_options.afterpay_clearpay',
    'payment_method_options.alipay',
    'payment_method_options.alma',
    'payment_method_options.amazon_pay',
    'payment_method_options.au_becs_debit',
    'payment_method_options.bacs_debit',
    'payment_method_options.bancontact',
    'payment_method_options.billie',
    'payment_method_options.billie.company_details',
    'payment_method_options.billie.company_details.registered_address',
    'payment_method_options.bizum',
    'payment_method_options.blik',
    'payment_method_options.boleto',
    'payment_method_options.card',
    'payment_method_options.card.buy_now_pay_later_options',
    'payment_method_options.card.installments.plan',
    'payment_method_options.card.recipient_details',
    'payment_method_options.card.sender_details',
    'payment_method_options.card.statement_details',
    'payment_method_options.card_present',
    'payment_method_options.card_present.buy_now_pay_later_options',
    'payment_method_options.card_present.recipient_details',
    'payment_method_options.card_present.sender_details',
    'payment_method_options.cashapp',
    'payment_method_options.click_to_pay',
    'payment_method_options.crypto',
    'payment_method_options.customer_balance',
    'payment_method_options.demo_pay',
    'payment_method_options.dummy_auth_push',
    'payment_method_options.dummy_passthrough_card',
    'payment_method_options.eps',
    'payment_method_options.fpx',
    'payment_method_options.getbalance',
    'payment_method_options.giropay',
    'payment_method_options.gopay',
    'payment_method_options.grabpay',
    'payment_method_options.id_bank_transfer',
    'payment_method_options.ideal',
    'payment_method_options.interac_present',
    'payment_method_options.kakao_pay',
    'payment_method_options.klarna',
    'payment_method_options.klarna.line_items',
    'payment_method_options.klarna.subscriptions',
    'payment_method_options.klarna.supplementary_purchase_data',
    'payment_method_options.klarna.supplementary_purchase_data.bus_reservation_details',
    'payment_method_options.klarna.supplementary_purchase_data.customer',
    'payment_method_options.klarna.supplementary_purchase_data.event_reservation_details',
    'payment_method_options.klarna.supplementary_purchase_data.ferry_reservation_details',
    'payment_method_options.klarna.supplementary_purchase_data.insurances',
    'payment_method_options.klarna.supplementary_purchase_data.marketplace_sellers',
    'payment_method_options.klarna.supplementary_purchase_data.round_trip_reservation_details',
    'payment_method_options.klarna.supplementary_purchase_data.train_reservation_details',
    'payment_method_options.klarna.supplementary_purchase_data.vouchers',
    'payment_method_options.knet',
    'payment_method_options.konbini',
    'payment_method_options.konbini.expires_after_days',
    'payment_method_options.konbini.expires_at',
    'payment_method_options.konbini.fee_amount',
    'payment_method_options.konbini.tax_amount',
    'payment_method_options.kr_card',
    'payment_method_options.kr_market',
    'payment_method_options.link',
    'payment_method_options.link.instant_debits.sellers',
    'payment_method_options.mb_way',
    'payment_method_options.mobilepay',
    'payment_method_options.mondu',
    'payment_method_options.multibanco',
    'payment_method_options.naver_pay',
    'payment_method_options.ng_bank',
    'payment_method_options.ng_bank_transfer',
    'payment_method_options.ng_card',
    'payment_method_options.ng_market',
    'payment_method_options.ng_ussd',
    'payment_method_options.nz_bank_account',
    'payment_method_options.oxxo',
    'payment_method_options.p24',
    'payment_method_options.pay_by_bank',
    'payment_method_options.payco',
    'payment_method_options.paynow',
    'payment_method_options.paypal',
    'payment_method_options.paypay',
    'payment_method_options.payto',
    'payment_method_options.payto.mandate_options.amount',
    'payment_method_options.payto.mandate_options.payments_per_period',
    'payment_method_options.pix',
    'payment_method_options.promptpay',
    'payment_method_options.qris',
    'payment_method_options.rechnung',
    'payment_method_options.revolut_pay',
    'payment_method_options.samsung_pay',
    'payment_method_options.satispay',
    'payment_method_options.scalapay',
    'payment_method_options.sepa_debit',
    'payment_method_options.shopeepay',
    'payment_method_options.sofort',
    'payment_method_options.stripe_balance',
    'payment_method_options.swish',
    'payment_method_options.twint',
    'payment_method_options.upi',
    'payment_method_options.us_bank_account',
    'payment_method_options.vipps',
    'payment_method_options.wechat_pay',
    'payment_method_options.zip',
    'revenue_recognition_settings',
  ],
  OpenapiPostV1RefundsInputMetadataMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodData: [
    'billing_details.address',
  ],
  OpenapiPostV1RefundsInputPaymentMethodDataBillingDetails: [
    'address',
  ],
  OpenapiPostV1RefundsInputPaymentMethodDataBillingDetailsAddressMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptions: [
    'acss_debit',
    'affirm',
    'afterpay_clearpay',
    'alipay',
    'alma',
    'amazon_pay',
    'au_becs_debit',
    'bacs_debit',
    'bancontact',
    'billie',
    'billie.company_details',
    'billie.company_details.registered_address',
    'bizum',
    'blik',
    'boleto',
    'card',
    'card.buy_now_pay_later_options',
    'card.installments.plan',
    'card.recipient_details',
    'card.sender_details',
    'card.statement_details',
    'card_present',
    'card_present.buy_now_pay_later_options',
    'card_present.recipient_details',
    'card_present.sender_details',
    'cashapp',
    'click_to_pay',
    'crypto',
    'customer_balance',
    'demo_pay',
    'dummy_auth_push',
    'dummy_passthrough_card',
    'eps',
    'fpx',
    'getbalance',
    'giropay',
    'gopay',
    'grabpay',
    'id_bank_transfer',
    'ideal',
    'interac_present',
    'kakao_pay',
    'klarna',
    'klarna.line_items',
    'klarna.subscriptions',
    'klarna.supplementary_purchase_data',
    'klarna.supplementary_purchase_data.bus_reservation_details',
    'klarna.supplementary_purchase_data.customer',
    'klarna.supplementary_purchase_data.event_reservation_details',
    'klarna.supplementary_purchase_data.ferry_reservation_details',
    'klarna.supplementary_purchase_data.insurances',
    'klarna.supplementary_purchase_data.marketplace_sellers',
    'klarna.supplementary_purchase_data.round_trip_reservation_details',
    'klarna.supplementary_purchase_data.train_reservation_details',
    'klarna.supplementary_purchase_data.vouchers',
    'knet',
    'konbini',
    'konbini.expires_after_days',
    'konbini.expires_at',
    'konbini.fee_amount',
    'konbini.tax_amount',
    'kr_card',
    'kr_market',
    'link',
    'link.instant_debits.sellers',
    'mb_way',
    'mobilepay',
    'mondu',
    'multibanco',
    'naver_pay',
    'ng_bank',
    'ng_bank_transfer',
    'ng_card',
    'ng_market',
    'ng_ussd',
    'nz_bank_account',
    'oxxo',
    'p24',
    'pay_by_bank',
    'payco',
    'paynow',
    'paypal',
    'paypay',
    'payto',
    'payto.mandate_options.amount',
    'payto.mandate_options.payments_per_period',
    'pix',
    'promptpay',
    'qris',
    'rechnung',
    'revolut_pay',
    'samsung_pay',
    'satispay',
    'scalapay',
    'sepa_debit',
    'shopeepay',
    'sofort',
    'stripe_balance',
    'swish',
    'twint',
    'upi',
    'us_bank_account',
    'vipps',
    'wechat_pay',
    'zip',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsAcssDebitMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsAffirmMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsAfterpayClearpayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsAlipayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsAlmaMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsAmazonPayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsAuBecsDebitMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsBacsDebitMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsBancontactMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsBillie: [
    'company_details',
    'company_details.registered_address',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsBillieCompanyDetails: [
    'registered_address',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsBillieCompanyDetailsMaybeEmpty: [
    'registered_address',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsBillieCompanyDetailsRegisteredAddressMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsBillieMaybeEmpty: [
    'company_details',
    'company_details.registered_address',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsBizumMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsBlikMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsBoletoMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCard: [
    'buy_now_pay_later_options',
    'installments.plan',
    'recipient_details',
    'sender_details',
    'statement_details',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCardBuyNowPayLaterOptionsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCardInstallments: [
    'plan',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCardInstallmentsPlanMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCardMaybeEmpty: [
    'buy_now_pay_later_options',
    'installments.plan',
    'recipient_details',
    'sender_details',
    'statement_details',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCardPresent: [
    'buy_now_pay_later_options',
    'recipient_details',
    'sender_details',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCardPresentBuyNowPayLaterOptionsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCardPresentMaybeEmpty: [
    'buy_now_pay_later_options',
    'recipient_details',
    'sender_details',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCardPresentRecipientDetailsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCardPresentSenderDetailsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCardRecipientDetailsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCardSenderDetailsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCardStatementDetailsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCashappMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsClickToPayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCryptoMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsCustomerBalanceMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsDemoPayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsDummyAuthPushMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsDummyPassthroughCardMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsEpsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsFpxMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsGetbalanceMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsGiropayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsGopayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsGrabpayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsIdBankTransferMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsIdealMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsInteracPresentMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKakaoPayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarna: [
    'line_items',
    'subscriptions',
    'supplementary_purchase_data',
    'supplementary_purchase_data.bus_reservation_details',
    'supplementary_purchase_data.customer',
    'supplementary_purchase_data.event_reservation_details',
    'supplementary_purchase_data.ferry_reservation_details',
    'supplementary_purchase_data.insurances',
    'supplementary_purchase_data.marketplace_sellers',
    'supplementary_purchase_data.round_trip_reservation_details',
    'supplementary_purchase_data.train_reservation_details',
    'supplementary_purchase_data.vouchers',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaLineItemsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaMaybeEmpty: [
    'line_items',
    'subscriptions',
    'supplementary_purchase_data',
    'supplementary_purchase_data.bus_reservation_details',
    'supplementary_purchase_data.customer',
    'supplementary_purchase_data.event_reservation_details',
    'supplementary_purchase_data.ferry_reservation_details',
    'supplementary_purchase_data.insurances',
    'supplementary_purchase_data.marketplace_sellers',
    'supplementary_purchase_data.round_trip_reservation_details',
    'supplementary_purchase_data.train_reservation_details',
    'supplementary_purchase_data.vouchers',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaSubscriptionsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseData: [
    'bus_reservation_details',
    'customer',
    'event_reservation_details',
    'ferry_reservation_details',
    'insurances',
    'marketplace_sellers',
    'round_trip_reservation_details',
    'train_reservation_details',
    'vouchers',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataBusReservationDetailsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataCustomerMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataEventReservationDetailsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataFerryReservationDetailsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataInsurancesMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataMarketplaceSellersMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataMaybeEmpty: [
    'bus_reservation_details',
    'customer',
    'event_reservation_details',
    'ferry_reservation_details',
    'insurances',
    'marketplace_sellers',
    'round_trip_reservation_details',
    'train_reservation_details',
    'vouchers',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataRoundTripReservationDetailsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataTrainReservationDetailsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKlarnaSupplementaryPurchaseDataVouchersMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKnetMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKonbini: [
    'expires_after_days',
    'expires_at',
    'fee_amount',
    'tax_amount',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKonbiniExpiresAfterDaysMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKonbiniExpiresAtMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKonbiniFeeAmountMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKonbiniMaybeEmpty: [
    'expires_after_days',
    'expires_at',
    'fee_amount',
    'tax_amount',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKonbiniTaxAmountMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKrCardMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsKrMarketMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsLink: [
    'instant_debits.sellers',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsLinkInstantDebits: [
    'sellers',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsLinkInstantDebitsSellersMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsLinkMaybeEmpty: [
    'instant_debits.sellers',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsMbWayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsMobilepayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsMonduMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsMultibancoMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsNaverPayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsNgBankMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsNgBankTransferMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsNgCardMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsNgMarketMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsNgUssdMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsNzBankAccountMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsOxxoMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsP24MaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsPayByBankMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsPaycoMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsPaynowMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsPaypalMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsPaypayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsPayto: [
    'mandate_options.amount',
    'mandate_options.payments_per_period',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsPaytoMandateOptions: [
    'amount',
    'payments_per_period',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsPaytoMandateOptionsAmountMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsPaytoMandateOptionsPaymentsPerPeriodMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsPaytoMaybeEmpty: [
    'mandate_options.amount',
    'mandate_options.payments_per_period',
  ],
  OpenapiPostV1RefundsInputPaymentMethodOptionsPixMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsPromptpayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsQrisMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsRechnungMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsRevolutPayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsSamsungPayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsSatispayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsScalapayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsSepaDebitMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsShopeepayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsSofortMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsStripeBalanceMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsSwishMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsTwintMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsUpiMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsVippsMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsWechatPayMaybeEmpty: [],
  OpenapiPostV1RefundsInputPaymentMethodOptionsZipMaybeEmpty: [],
  OpenapiPostV1RefundsInputRevenueRecognitionSettingsMaybeEmpty: [],
  OpenapiPostV1RefundsRefundInput: [
    'metadata',
  ],
  OpenapiPostV1RefundsRefundInputMetadataMaybeEmpty: [],
  OpenapiPostV1ReserveHoldsIdInput: [
    'metadata',
  ],
  OpenapiPostV1ReserveHoldsIdInputMetadataMaybeEmpty: [],
  OpenapiPostV1ReservePlansIdInput: [
    'metadata',
    'rolling_release.expires_on',
  ],
  OpenapiPostV1ReservePlansIdInputMetadataMaybeEmpty: [],
  OpenapiPostV1ReservePlansIdInputRollingRelease: [
    'expires_on',
  ],
  OpenapiPostV1ReservePlansIdInputRollingReleaseExpiresOnMaybeEmpty: [],
  OpenapiPostV1SetupIntentsInput: [
    'mandate_data',
    'payment_method_data.billing_details.address',
    'payment_method_options.klarna.subscriptions',
    'payment_method_options.payto.mandate_options.amount',
    'payment_method_options.payto.mandate_options.payments_per_period',
    'setup_details.benefit.fr_meal_voucher',
  ],
  OpenapiPostV1SetupIntentsInputMandateDataMaybeEmpty: [],
  OpenapiPostV1SetupIntentsInputPaymentMethodData: [
    'billing_details.address',
  ],
  OpenapiPostV1SetupIntentsInputPaymentMethodDataBillingDetails: [
    'address',
  ],
  OpenapiPostV1SetupIntentsInputPaymentMethodDataBillingDetailsAddressMaybeEmpty: [],
  OpenapiPostV1SetupIntentsInputPaymentMethodOptions: [
    'klarna.subscriptions',
    'payto.mandate_options.amount',
    'payto.mandate_options.payments_per_period',
  ],
  OpenapiPostV1SetupIntentsInputPaymentMethodOptionsKlarna: [
    'subscriptions',
  ],
  OpenapiPostV1SetupIntentsInputPaymentMethodOptionsKlarnaSubscriptionsMaybeEmpty: [],
  OpenapiPostV1SetupIntentsInputPaymentMethodOptionsPayto: [
    'mandate_options.amount',
    'mandate_options.payments_per_period',
  ],
  OpenapiPostV1SetupIntentsInputPaymentMethodOptionsPaytoMandateOptions: [
    'amount',
    'payments_per_period',
  ],
  OpenapiPostV1SetupIntentsInputPaymentMethodOptionsPaytoMandateOptionsAmountMaybeEmpty: [],
  OpenapiPostV1SetupIntentsInputPaymentMethodOptionsPaytoMandateOptionsPaymentsPerPeriodMaybeEmpty: [],
  OpenapiPostV1SetupIntentsInputSetupDetails: [
    'benefit.fr_meal_voucher',
  ],
  OpenapiPostV1SetupIntentsInputSetupDetailsBenefit: [
    'fr_meal_voucher',
  ],
  OpenapiPostV1SetupIntentsInputSetupDetailsBenefitFrMealVoucherMaybeEmpty: [],
  OpenapiPostV1SetupIntentsIntentInput: [
    'excluded_payment_method_types',
    'metadata',
    'payment_method_data.billing_details.address',
    'payment_method_options.klarna.subscriptions',
    'payment_method_options.payto.mandate_options.amount',
    'payment_method_options.payto.mandate_options.payments_per_period',
    'setup_details.benefit.fr_meal_voucher',
  ],
  OpenapiPostV1SetupIntentsIntentInputExcludedPaymentMethodTypesMaybeEmpty: [],
  OpenapiPostV1SetupIntentsIntentInputMetadataMaybeEmpty: [],
  OpenapiPostV1SetupIntentsIntentInputPaymentMethodData: [
    'billing_details.address',
  ],
  OpenapiPostV1SetupIntentsIntentInputPaymentMethodDataBillingDetails: [
    'address',
  ],
  OpenapiPostV1SetupIntentsIntentInputPaymentMethodDataBillingDetailsAddressMaybeEmpty: [],
  OpenapiPostV1SetupIntentsIntentInputPaymentMethodOptions: [
    'klarna.subscriptions',
    'payto.mandate_options.amount',
    'payto.mandate_options.payments_per_period',
  ],
  OpenapiPostV1SetupIntentsIntentInputPaymentMethodOptionsKlarna: [
    'subscriptions',
  ],
  OpenapiPostV1SetupIntentsIntentInputPaymentMethodOptionsKlarnaSubscriptionsMaybeEmpty: [],
  OpenapiPostV1SetupIntentsIntentInputPaymentMethodOptionsPayto: [
    'mandate_options.amount',
    'mandate_options.payments_per_period',
  ],
  OpenapiPostV1SetupIntentsIntentInputPaymentMethodOptionsPaytoMandateOptions: [
    'amount',
    'payments_per_period',
  ],
  OpenapiPostV1SetupIntentsIntentInputPaymentMethodOptionsPaytoMandateOptionsAmountMaybeEmpty: [],
  OpenapiPostV1SetupIntentsIntentInputPaymentMethodOptionsPaytoMandateOptionsPaymentsPerPeriodMaybeEmpty: [],
  OpenapiPostV1SetupIntentsIntentInputSetupDetails: [
    'benefit.fr_meal_voucher',
  ],
  OpenapiPostV1SetupIntentsIntentInputSetupDetailsBenefit: [
    'fr_meal_voucher',
  ],
  OpenapiPostV1SetupIntentsIntentInputSetupDetailsBenefitFrMealVoucherMaybeEmpty: [],
  OpenapiPostV1SigmaOrganizationQueryFilesOrganizationQueryFileInput: [
    'requested_compartments',
  ],
  OpenapiPostV1SigmaOrganizationQueryFilesOrganizationQueryFileInputRequestedCompartmentsMaybeEmpty: [],
  OpenapiPostV1SigmaScheduledQueriesInput: [
    'emails',
  ],
  OpenapiPostV1SigmaScheduledQueriesInputEmailsMaybeEmpty: [],
  OpenapiPostV1SigmaScheduledQueriesScheduledQueryInput: [
    'emails',
  ],
  OpenapiPostV1SigmaScheduledQueriesScheduledQueryInputEmailsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInput: [
    'default_settings.billing_thresholds',
    'default_settings.invoice_settings.account_tax_ids',
    'default_settings.invoice_settings.custom_fields',
    'default_settings.invoice_settings.rendering',
    'default_settings.invoice_settings.rendering.template_version',
    'default_settings.transfer_data',
    'metadata',
    'phases.add_invoice_items.tax_rates',
    'phases.billing_thresholds',
    'phases.default_tax_rates',
    'phases.discounts',
    'phases.invoice_settings.account_tax_ids',
    'phases.invoice_settings.custom_fields',
    'phases.items.billing_thresholds',
    'phases.items.discounts',
    'phases.items.tax_rates',
    'phases.payment_settings.payment_method_options.acss_debit',
    'phases.payment_settings.payment_method_options.bancontact',
    'phases.payment_settings.payment_method_options.card',
    'phases.payment_settings.payment_method_options.card.mit_exemption',
    'phases.payment_settings.payment_method_options.customer_balance',
    'phases.payment_settings.payment_method_options.id_bank_transfer',
    'phases.payment_settings.payment_method_options.konbini',
    'phases.payment_settings.payment_method_options.payto',
    'phases.payment_settings.payment_method_options.pix',
    'phases.payment_settings.payment_method_options.sepa_debit',
    'phases.payment_settings.payment_method_options.upi',
    'phases.payment_settings.payment_method_options.us_bank_account',
    'phases.payment_settings.payment_method_types',
  ],
  OpenapiPostV1SubscriptionSchedulesInputDefaultSettings: [
    'billing_thresholds',
    'invoice_settings.account_tax_ids',
    'invoice_settings.custom_fields',
    'invoice_settings.rendering',
    'invoice_settings.rendering.template_version',
    'transfer_data',
  ],
  OpenapiPostV1SubscriptionSchedulesInputDefaultSettingsBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputDefaultSettingsInvoiceSettings: [
    'account_tax_ids',
    'custom_fields',
    'rendering',
    'rendering.template_version',
  ],
  OpenapiPostV1SubscriptionSchedulesInputDefaultSettingsInvoiceSettingsAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputDefaultSettingsInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputDefaultSettingsInvoiceSettingsRendering: [
    'template_version',
  ],
  OpenapiPostV1SubscriptionSchedulesInputDefaultSettingsInvoiceSettingsRenderingMaybeEmpty: [
    'template_version',
  ],
  OpenapiPostV1SubscriptionSchedulesInputDefaultSettingsInvoiceSettingsRenderingTemplateVersionMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputDefaultSettingsTransferDataMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputMetadataMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhases: [
    'add_invoice_items.tax_rates',
    'billing_thresholds',
    'default_tax_rates',
    'discounts',
    'invoice_settings.account_tax_ids',
    'invoice_settings.custom_fields',
    'items.billing_thresholds',
    'items.discounts',
    'items.tax_rates',
    'payment_settings.payment_method_options.acss_debit',
    'payment_settings.payment_method_options.bancontact',
    'payment_settings.payment_method_options.card',
    'payment_settings.payment_method_options.card.mit_exemption',
    'payment_settings.payment_method_options.customer_balance',
    'payment_settings.payment_method_options.id_bank_transfer',
    'payment_settings.payment_method_options.konbini',
    'payment_settings.payment_method_options.payto',
    'payment_settings.payment_method_options.pix',
    'payment_settings.payment_method_options.sepa_debit',
    'payment_settings.payment_method_options.upi',
    'payment_settings.payment_method_options.us_bank_account',
    'payment_settings.payment_method_types',
  ],
  OpenapiPostV1SubscriptionSchedulesInputPhasesAddInvoiceItems: [
    'tax_rates',
  ],
  OpenapiPostV1SubscriptionSchedulesInputPhasesAddInvoiceItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesDefaultTaxRatesMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesDiscountsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesInvoiceSettings: [
    'account_tax_ids',
    'custom_fields',
  ],
  OpenapiPostV1SubscriptionSchedulesInputPhasesInvoiceSettingsAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesItems: [
    'billing_thresholds',
    'discounts',
    'tax_rates',
  ],
  OpenapiPostV1SubscriptionSchedulesInputPhasesItemsBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesItemsDiscountsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettings: [
    'payment_method_options.acss_debit',
    'payment_method_options.bancontact',
    'payment_method_options.card',
    'payment_method_options.card.mit_exemption',
    'payment_method_options.customer_balance',
    'payment_method_options.id_bank_transfer',
    'payment_method_options.konbini',
    'payment_method_options.payto',
    'payment_method_options.pix',
    'payment_method_options.sepa_debit',
    'payment_method_options.upi',
    'payment_method_options.us_bank_account',
    'payment_method_types',
  ],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptions: [
    'acss_debit',
    'bancontact',
    'card',
    'card.mit_exemption',
    'customer_balance',
    'id_bank_transfer',
    'konbini',
    'payto',
    'pix',
    'sepa_debit',
    'upi',
    'us_bank_account',
  ],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsAcssDebitMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsBancontactMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsCard: [
    'mit_exemption',
  ],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsCardMaybeEmpty: [
    'mit_exemption',
  ],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsCardMitExemptionMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsCustomerBalanceMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsIdBankTransferMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsKonbiniMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsPaytoMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsPixMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsSepaDebitMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsUpiMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesInputPhasesPaymentSettingsPaymentMethodTypesMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInput: [
    'billing_schedules',
    'default_settings.billing_thresholds',
    'default_settings.invoice_settings.account_tax_ids',
    'default_settings.invoice_settings.custom_fields',
    'default_settings.invoice_settings.rendering',
    'default_settings.invoice_settings.rendering.template_version',
    'default_settings.transfer_data',
    'initial_billing_cycle_anchor',
    'metadata',
    'phases.add_invoice_items.tax_rates',
    'phases.billing_thresholds',
    'phases.default_tax_rates',
    'phases.discounts',
    'phases.invoice_settings.account_tax_ids',
    'phases.invoice_settings.custom_fields',
    'phases.items.billing_thresholds',
    'phases.items.discounts',
    'phases.items.tax_rates',
    'phases.payment_settings.payment_method_options.acss_debit',
    'phases.payment_settings.payment_method_options.bancontact',
    'phases.payment_settings.payment_method_options.card',
    'phases.payment_settings.payment_method_options.card.mit_exemption',
    'phases.payment_settings.payment_method_options.customer_balance',
    'phases.payment_settings.payment_method_options.id_bank_transfer',
    'phases.payment_settings.payment_method_options.konbini',
    'phases.payment_settings.payment_method_options.payto',
    'phases.payment_settings.payment_method_options.pix',
    'phases.payment_settings.payment_method_options.sepa_debit',
    'phases.payment_settings.payment_method_options.upi',
    'phases.payment_settings.payment_method_options.us_bank_account',
    'phases.payment_settings.payment_method_types',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputBillingSchedulesMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputDefaultSettings: [
    'billing_thresholds',
    'invoice_settings.account_tax_ids',
    'invoice_settings.custom_fields',
    'invoice_settings.rendering',
    'invoice_settings.rendering.template_version',
    'transfer_data',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputDefaultSettingsBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputDefaultSettingsInvoiceSettings: [
    'account_tax_ids',
    'custom_fields',
    'rendering',
    'rendering.template_version',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputDefaultSettingsInvoiceSettingsAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputDefaultSettingsInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputDefaultSettingsInvoiceSettingsRendering: [
    'template_version',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputDefaultSettingsInvoiceSettingsRenderingMaybeEmpty: [
    'template_version',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputDefaultSettingsInvoiceSettingsRenderingTemplateVersionMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputDefaultSettingsTransferDataMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputInitialBillingCycleAnchorMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputMetadataMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhases: [
    'add_invoice_items.tax_rates',
    'billing_thresholds',
    'default_tax_rates',
    'discounts',
    'invoice_settings.account_tax_ids',
    'invoice_settings.custom_fields',
    'items.billing_thresholds',
    'items.discounts',
    'items.tax_rates',
    'payment_settings.payment_method_options.acss_debit',
    'payment_settings.payment_method_options.bancontact',
    'payment_settings.payment_method_options.card',
    'payment_settings.payment_method_options.card.mit_exemption',
    'payment_settings.payment_method_options.customer_balance',
    'payment_settings.payment_method_options.id_bank_transfer',
    'payment_settings.payment_method_options.konbini',
    'payment_settings.payment_method_options.payto',
    'payment_settings.payment_method_options.pix',
    'payment_settings.payment_method_options.sepa_debit',
    'payment_settings.payment_method_options.upi',
    'payment_settings.payment_method_options.us_bank_account',
    'payment_settings.payment_method_types',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesAddInvoiceItems: [
    'tax_rates',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesAddInvoiceItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesDefaultTaxRatesMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesDiscountsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesInvoiceSettings: [
    'account_tax_ids',
    'custom_fields',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesInvoiceSettingsAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesItems: [
    'billing_thresholds',
    'discounts',
    'tax_rates',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesItemsBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesItemsDiscountsMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettings: [
    'payment_method_options.acss_debit',
    'payment_method_options.bancontact',
    'payment_method_options.card',
    'payment_method_options.card.mit_exemption',
    'payment_method_options.customer_balance',
    'payment_method_options.id_bank_transfer',
    'payment_method_options.konbini',
    'payment_method_options.payto',
    'payment_method_options.pix',
    'payment_method_options.sepa_debit',
    'payment_method_options.upi',
    'payment_method_options.us_bank_account',
    'payment_method_types',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptions: [
    'acss_debit',
    'bancontact',
    'card',
    'card.mit_exemption',
    'customer_balance',
    'id_bank_transfer',
    'konbini',
    'payto',
    'pix',
    'sepa_debit',
    'upi',
    'us_bank_account',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsAcssDebitMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsBancontactMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsCard: [
    'mit_exemption',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsCardMaybeEmpty: [
    'mit_exemption',
  ],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsCardMitExemptionMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsCustomerBalanceMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsIdBankTransferMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsKonbiniMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsPaytoMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsPixMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsSepaDebitMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsUpiMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiPostV1SubscriptionSchedulesScheduleInputPhasesPaymentSettingsPaymentMethodTypesMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInput: [
    'add_invoice_items.tax_rates',
    'application_fee_percent',
    'billing_thresholds',
    'default_tax_rates',
    'discounts',
    'invoice_settings.account_tax_ids',
    'invoice_settings.custom_fields',
    'invoice_settings.rendering',
    'invoice_settings.rendering.template_version',
    'items.billing_thresholds',
    'items.discounts',
    'items.tax_rates',
    'metadata',
    'payment_settings.payment_method_options.acss_debit',
    'payment_settings.payment_method_options.bancontact',
    'payment_settings.payment_method_options.card',
    'payment_settings.payment_method_options.card.mit_exemption',
    'payment_settings.payment_method_options.customer_balance',
    'payment_settings.payment_method_options.id_bank_transfer',
    'payment_settings.payment_method_options.konbini',
    'payment_settings.payment_method_options.payto',
    'payment_settings.payment_method_options.pix',
    'payment_settings.payment_method_options.sepa_debit',
    'payment_settings.payment_method_options.upi',
    'payment_settings.payment_method_options.us_bank_account',
    'payment_settings.payment_method_types',
    'pending_invoice_item_interval',
    'tax_percent',
  ],
  OpenapiPostV1SubscriptionsInputAddInvoiceItems: [
    'tax_rates',
  ],
  OpenapiPostV1SubscriptionsInputAddInvoiceItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputApplicationFeePercentMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputDefaultTaxRatesMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputDiscountsMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputInvoiceSettings: [
    'account_tax_ids',
    'custom_fields',
    'rendering',
    'rendering.template_version',
  ],
  OpenapiPostV1SubscriptionsInputInvoiceSettingsAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputInvoiceSettingsRendering: [
    'template_version',
  ],
  OpenapiPostV1SubscriptionsInputInvoiceSettingsRenderingMaybeEmpty: [
    'template_version',
  ],
  OpenapiPostV1SubscriptionsInputInvoiceSettingsRenderingTemplateVersionMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputItems: [
    'billing_thresholds',
    'discounts',
    'tax_rates',
  ],
  OpenapiPostV1SubscriptionsInputItemsBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputItemsDiscountsMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputMetadataMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPaymentSettings: [
    'payment_method_options.acss_debit',
    'payment_method_options.bancontact',
    'payment_method_options.card',
    'payment_method_options.card.mit_exemption',
    'payment_method_options.customer_balance',
    'payment_method_options.id_bank_transfer',
    'payment_method_options.konbini',
    'payment_method_options.payto',
    'payment_method_options.pix',
    'payment_method_options.sepa_debit',
    'payment_method_options.upi',
    'payment_method_options.us_bank_account',
    'payment_method_types',
  ],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptions: [
    'acss_debit',
    'bancontact',
    'card',
    'card.mit_exemption',
    'customer_balance',
    'id_bank_transfer',
    'konbini',
    'payto',
    'pix',
    'sepa_debit',
    'upi',
    'us_bank_account',
  ],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsAcssDebitMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsBancontactMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsCard: [
    'mit_exemption',
  ],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsCardMaybeEmpty: [
    'mit_exemption',
  ],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsCardMitExemptionMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsCustomerBalanceMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsIdBankTransferMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsKonbiniMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsPaytoMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsPixMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsSepaDebitMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsUpiMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPaymentSettingsPaymentMethodTypesMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputPendingInvoiceItemIntervalMaybeEmpty: [],
  OpenapiPostV1SubscriptionsInputTaxPercentMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInput: [
    'add_invoice_items.tax_rates',
    'application_fee_percent',
    'billing_schedules',
    'billing_thresholds',
    'cancel_at_dashboard_only',
    'default_tax_rates',
    'discounts',
    'invoice_settings.account_tax_ids',
    'invoice_settings.custom_fields',
    'invoice_settings.rendering',
    'invoice_settings.rendering.template_version',
    'items.billing_thresholds',
    'items.discounts',
    'items.metadata',
    'items.tax_rates',
    'metadata',
    'pause_collection',
    'payment_settings.payment_method_options.acss_debit',
    'payment_settings.payment_method_options.bancontact',
    'payment_settings.payment_method_options.card',
    'payment_settings.payment_method_options.card.mit_exemption',
    'payment_settings.payment_method_options.customer_balance',
    'payment_settings.payment_method_options.id_bank_transfer',
    'payment_settings.payment_method_options.konbini',
    'payment_settings.payment_method_options.payto',
    'payment_settings.payment_method_options.pix',
    'payment_settings.payment_method_options.sepa_debit',
    'payment_settings.payment_method_options.upi',
    'payment_settings.payment_method_options.us_bank_account',
    'payment_settings.payment_method_types',
    'pending_invoice_item_interval',
    'tax_percent',
    'transfer_data',
  ],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputAddInvoiceItems: [
    'tax_rates',
  ],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputAddInvoiceItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputApplicationFeePercentMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputBillingSchedulesMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputCancelAtDashboardOnlyMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputDefaultTaxRatesMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputDiscountsMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputInvoiceSettings: [
    'account_tax_ids',
    'custom_fields',
    'rendering',
    'rendering.template_version',
  ],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputInvoiceSettingsAccountTaxIdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputInvoiceSettingsCustomFieldsMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputInvoiceSettingsRendering: [
    'template_version',
  ],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputInvoiceSettingsRenderingMaybeEmpty: [
    'template_version',
  ],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputInvoiceSettingsRenderingTemplateVersionMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputItems: [
    'billing_thresholds',
    'discounts',
    'metadata',
    'tax_rates',
  ],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputItemsBillingThresholdsMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputItemsDiscountsMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputItemsMetadataMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputItemsTaxRatesMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputMetadataMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPauseCollectionMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettings: [
    'payment_method_options.acss_debit',
    'payment_method_options.bancontact',
    'payment_method_options.card',
    'payment_method_options.card.mit_exemption',
    'payment_method_options.customer_balance',
    'payment_method_options.id_bank_transfer',
    'payment_method_options.konbini',
    'payment_method_options.payto',
    'payment_method_options.pix',
    'payment_method_options.sepa_debit',
    'payment_method_options.upi',
    'payment_method_options.us_bank_account',
    'payment_method_types',
  ],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptions: [
    'acss_debit',
    'bancontact',
    'card',
    'card.mit_exemption',
    'customer_balance',
    'id_bank_transfer',
    'konbini',
    'payto',
    'pix',
    'sepa_debit',
    'upi',
    'us_bank_account',
  ],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsAcssDebitMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsBancontactMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsCard: [
    'mit_exemption',
  ],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsCardMaybeEmpty: [
    'mit_exemption',
  ],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsCardMitExemptionMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsCustomerBalanceMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsIdBankTransferMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsKonbiniMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsPaytoMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsPixMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsSepaDebitMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsUpiMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPaymentSettingsPaymentMethodTypesMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputPendingInvoiceItemIntervalMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputTaxPercentMaybeEmpty: [],
  OpenapiPostV1SubscriptionsSubscriptionExposedIdInputTransferDataMaybeEmpty: [],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInput: [
    'information.partner_onboarding.business.is_marketplace',
    'information.partner_onboarding.business.is_marketplace_only',
    'information.partner_onboarding.business.mailing_address_is_same',
    'information.registration_details.amount_due_on_return',
    'information.registration_details.gross_receipts',
    'information.registration_details.last_payment_amount',
    'information.tax_details.last_payment_amount',
  ],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInputInformation: [
    'partner_onboarding.business.is_marketplace',
    'partner_onboarding.business.is_marketplace_only',
    'partner_onboarding.business.mailing_address_is_same',
    'registration_details.amount_due_on_return',
    'registration_details.gross_receipts',
    'registration_details.last_payment_amount',
    'tax_details.last_payment_amount',
  ],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInputInformationPartnerOnboarding: [
    'business.is_marketplace',
    'business.is_marketplace_only',
    'business.mailing_address_is_same',
  ],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInputInformationPartnerOnboardingBusiness: [
    'is_marketplace',
    'is_marketplace_only',
    'mailing_address_is_same',
  ],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInputInformationPartnerOnboardingBusinessIsMarketplaceMaybeEmpty: [],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInputInformationPartnerOnboardingBusinessIsMarketplaceOnlyMaybeEmpty: [],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInputInformationPartnerOnboardingBusinessMailingAddressIsSameMaybeEmpty: [],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInputInformationRegistrationDetails: [
    'amount_due_on_return',
    'gross_receipts',
    'last_payment_amount',
  ],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInputInformationRegistrationDetailsAmountDueOnReturnMaybeEmpty: [],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInputInformationRegistrationDetailsGrossReceiptsMaybeEmpty: [],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInputInformationRegistrationDetailsLastPaymentAmountMaybeEmpty: [],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInputInformationTaxDetails: [
    'last_payment_amount',
  ],
  OpenapiPostV1TaxFilingEnrollmentApplicationsIdInputInformationTaxDetailsLastPaymentAmountMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInput: [
    'has_confirmed_not_registered',
    'has_met_requirements_set_by_state',
    'information.business.has_sales_through_marketplaces',
    'information.business.is_marketplace',
    'information.business.is_professional',
    'information.business.is_seasonal_business',
    'information.business.is_taxed_differently',
    'information.business.mailing_address_is_same',
    'information.business.months_of_business',
    'information.business.sales_through_marketplaces',
    'information.business_ownership.business_owners_entity',
    'information.business_ownership.business_owners_entity.ownership_percentage',
    'information.business_ownership.business_owners_person',
    'information.business_ownership.business_owners_person.ownership_percentage',
    'information.business_ownership.option_pool_percentage',
    'information.business_ownership.other_ownership_percentage',
    'information.collect_single_local_use_tax_rate',
    'information.has_crossed_transaction_number_threshold',
    'information.is_skipped_pre_work',
    'information.prior_year_sales',
  ],
  OpenapiPostV1TaxRegistrationApplicationsIdInputHasConfirmedNotRegisteredMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputHasMetRequirementsSetByStateMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformation: [
    'business.has_sales_through_marketplaces',
    'business.is_marketplace',
    'business.is_professional',
    'business.is_seasonal_business',
    'business.is_taxed_differently',
    'business.mailing_address_is_same',
    'business.months_of_business',
    'business.sales_through_marketplaces',
    'business_ownership.business_owners_entity',
    'business_ownership.business_owners_entity.ownership_percentage',
    'business_ownership.business_owners_person',
    'business_ownership.business_owners_person.ownership_percentage',
    'business_ownership.option_pool_percentage',
    'business_ownership.other_ownership_percentage',
    'collect_single_local_use_tax_rate',
    'has_crossed_transaction_number_threshold',
    'is_skipped_pre_work',
    'prior_year_sales',
  ],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusiness: [
    'has_sales_through_marketplaces',
    'is_marketplace',
    'is_professional',
    'is_seasonal_business',
    'is_taxed_differently',
    'mailing_address_is_same',
    'months_of_business',
    'sales_through_marketplaces',
  ],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessHasSalesThroughMarketplacesMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessIsMarketplaceMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessIsProfessionalMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessIsSeasonalBusinessMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessIsTaxedDifferentlyMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessMailingAddressIsSameMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessMonthsOfBusinessMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessOwnership: [
    'business_owners_entity',
    'business_owners_entity.ownership_percentage',
    'business_owners_person',
    'business_owners_person.ownership_percentage',
    'option_pool_percentage',
    'other_ownership_percentage',
  ],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessOwnershipBusinessOwnersEntity: [
    'ownership_percentage',
  ],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessOwnershipBusinessOwnersEntityMaybeEmpty: [
    'ownership_percentage',
  ],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessOwnershipBusinessOwnersEntityOwnershipPercentageMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessOwnershipBusinessOwnersPerson: [
    'ownership_percentage',
  ],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessOwnershipBusinessOwnersPersonMaybeEmpty: [
    'ownership_percentage',
  ],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessOwnershipBusinessOwnersPersonOwnershipPercentageMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessOwnershipOptionPoolPercentageMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessOwnershipOtherOwnershipPercentageMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationBusinessSalesThroughMarketplacesMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationCollectSingleLocalUseTaxRateMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationHasCrossedTransactionNumberThresholdMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationIsSkippedPreWorkMaybeEmpty: [],
  OpenapiPostV1TaxRegistrationApplicationsIdInputInformationPriorYearSalesMaybeEmpty: [],
  OpenapiPostV1TaxReportingFatcaCrsFormInput: [
    'controlling_persons',
    'controlling_persons.dob',
    'controlling_persons.full_name_aliases',
    'controlling_persons.metadata',
    'controlling_persons.relationship.percent_ownership',
    'controlling_persons.tax_residencies',
    'tax_residencies',
  ],
  OpenapiPostV1TaxReportingFatcaCrsFormInputControllingPersons: [
    'dob',
    'full_name_aliases',
    'metadata',
    'relationship.percent_ownership',
    'tax_residencies',
  ],
  OpenapiPostV1TaxReportingFatcaCrsFormInputControllingPersonsDobMaybeEmpty: [],
  OpenapiPostV1TaxReportingFatcaCrsFormInputControllingPersonsFullNameAliasesMaybeEmpty: [],
  OpenapiPostV1TaxReportingFatcaCrsFormInputControllingPersonsMaybeEmpty: [
    'dob',
    'full_name_aliases',
    'metadata',
    'relationship.percent_ownership',
    'tax_residencies',
  ],
  OpenapiPostV1TaxReportingFatcaCrsFormInputControllingPersonsMetadataMaybeEmpty: [],
  OpenapiPostV1TaxReportingFatcaCrsFormInputControllingPersonsRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1TaxReportingFatcaCrsFormInputControllingPersonsRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1TaxReportingFatcaCrsFormInputControllingPersonsTaxResidenciesMaybeEmpty: [],
  OpenapiPostV1TaxReportingFatcaCrsFormInputTaxResidenciesMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInput: [
    'app_theme',
    'bbpos_wisepad3',
    'bbpos_wisepos_e',
    'cellular',
    'checkout_apps',
    'dynamic_currency_conversion',
    'offline',
    'reader_security',
    'reboot_window',
    'standalone',
    'standalone.reader_security',
    'stripe_s700',
    'stripe_s710',
    'stripe_t600',
    'stripe_t610',
    'tipping',
    'verifone_m425',
    'verifone_m450',
    'verifone_p400',
    'verifone_p630',
    'verifone_ux700',
    'verifone_v660p',
    'verifone_vl100',
    'verifone_vl110',
    'verifone_vm100',
    'verifone_vm110',
    'verifone_vp100',
    'verifone_vp110',
    'wifi',
  ],
  OpenapiPostV1TerminalConfigurationsConfigurationInputAppThemeMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputBbposWisepad3MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputBbposWiseposEMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputCellularMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputCheckoutAppsMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputDynamicCurrencyConversionMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputOfflineMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputReaderSecurityMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputRebootWindowMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputStandalone: [
    'reader_security',
  ],
  OpenapiPostV1TerminalConfigurationsConfigurationInputStandaloneMaybeEmpty: [
    'reader_security',
  ],
  OpenapiPostV1TerminalConfigurationsConfigurationInputStandaloneReaderSecurityMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputStripeS700MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputStripeS710MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputStripeT600MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputStripeT610MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputTippingMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputVerifoneM425MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputVerifoneM450MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputVerifoneP400MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputVerifoneP630MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputVerifoneUx700MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputVerifoneV660pMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputVerifoneVl100MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputVerifoneVl110MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputVerifoneVm100MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputVerifoneVm110MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputVerifoneVp100MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputVerifoneVp110MaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsConfigurationInputWifiMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsInput: [
    'app_theme',
    'cellular',
    'checkout_apps',
    'dynamic_currency_conversion',
    'offline',
    'reader_security',
    'standalone',
    'standalone.reader_security',
    'tipping',
    'wifi',
  ],
  OpenapiPostV1TerminalConfigurationsInputAppThemeMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsInputCellularMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsInputCheckoutAppsMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsInputDynamicCurrencyConversionMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsInputOfflineMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsInputReaderSecurityMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsInputStandalone: [
    'reader_security',
  ],
  OpenapiPostV1TerminalConfigurationsInputStandaloneMaybeEmpty: [
    'reader_security',
  ],
  OpenapiPostV1TerminalConfigurationsInputStandaloneReaderSecurityMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsInputTippingMaybeEmpty: [],
  OpenapiPostV1TerminalConfigurationsInputWifiMaybeEmpty: [],
  OpenapiPostV1TerminalLocationsInput: [
    'metadata',
  ],
  OpenapiPostV1TerminalLocationsInputMetadataMaybeEmpty: [],
  OpenapiPostV1TerminalLocationsLocationInput: [
    'capabilities_settings.paypay_in_person_payments',
    'device_deploy_groups_v2',
    'metadata',
  ],
  OpenapiPostV1TerminalLocationsLocationInputCapabilitiesSettings: [
    'paypay_in_person_payments',
  ],
  OpenapiPostV1TerminalLocationsLocationInputCapabilitiesSettingsPaypayInPersonPaymentsMaybeEmpty: [],
  OpenapiPostV1TerminalLocationsLocationInputDeviceDeployGroupsV2MaybeEmpty: [],
  OpenapiPostV1TerminalLocationsLocationInputMetadataMaybeEmpty: [],
  OpenapiPostV1TerminalReadersInput: [
    'metadata',
  ],
  OpenapiPostV1TerminalReadersInputMetadataMaybeEmpty: [],
  OpenapiPostV1TerminalReadersReaderInput: [
    'metadata',
  ],
  OpenapiPostV1TerminalReadersReaderInputMetadataMaybeEmpty: [],
  OpenapiPostV1TestHelpersDelegatedCheckoutRequestedSessionsRequestedSessionInput: [
    'metadata',
    'payment_method_data',
    'shared_metadata',
  ],
  OpenapiPostV1TestHelpersDelegatedCheckoutRequestedSessionsRequestedSessionInputMetadataMaybeEmpty: [],
  OpenapiPostV1TestHelpersDelegatedCheckoutRequestedSessionsRequestedSessionInputPaymentMethodDataMaybeEmpty: [],
  OpenapiPostV1TestHelpersDelegatedCheckoutRequestedSessionsRequestedSessionInputSharedMetadataMaybeEmpty: [],
  OpenapiPostV1TokensInput: [
    'account.company.registration_date',
    'account.individual.dob',
    'account.individual.full_name_aliases',
    'account.individual.metadata',
    'account.individual.percent_ownership',
    'account.individual.personal_relationship.percent_ownership',
    'account.individual.relationship.percent_ownership',
    'person.dob',
    'person.full_name_aliases',
    'person.metadata',
    'person.relationship.percent_ownership',
  ],
  OpenapiPostV1TokensInputAccount: [
    'company.registration_date',
    'individual.dob',
    'individual.full_name_aliases',
    'individual.metadata',
    'individual.percent_ownership',
    'individual.personal_relationship.percent_ownership',
    'individual.relationship.percent_ownership',
  ],
  OpenapiPostV1TokensInputAccountCompany: [
    'registration_date',
  ],
  OpenapiPostV1TokensInputAccountCompanyRegistrationDateMaybeEmpty: [],
  OpenapiPostV1TokensInputAccountIndividual: [
    'dob',
    'full_name_aliases',
    'metadata',
    'percent_ownership',
    'personal_relationship.percent_ownership',
    'relationship.percent_ownership',
  ],
  OpenapiPostV1TokensInputAccountIndividualDobMaybeEmpty: [],
  OpenapiPostV1TokensInputAccountIndividualFullNameAliasesMaybeEmpty: [],
  OpenapiPostV1TokensInputAccountIndividualMetadataMaybeEmpty: [],
  OpenapiPostV1TokensInputAccountIndividualPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1TokensInputAccountIndividualPersonalRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1TokensInputAccountIndividualPersonalRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1TokensInputAccountIndividualRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1TokensInputAccountIndividualRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1TokensInputPerson: [
    'dob',
    'full_name_aliases',
    'metadata',
    'relationship.percent_ownership',
  ],
  OpenapiPostV1TokensInputPersonDobMaybeEmpty: [],
  OpenapiPostV1TokensInputPersonFullNameAliasesMaybeEmpty: [],
  OpenapiPostV1TokensInputPersonMetadataMaybeEmpty: [],
  OpenapiPostV1TokensInputPersonRelationship: [
    'percent_ownership',
  ],
  OpenapiPostV1TokensInputPersonRelationshipPercentOwnershipMaybeEmpty: [],
  OpenapiPostV1TopupsInput: [
    'metadata',
  ],
  OpenapiPostV1TopupsInputMetadataMaybeEmpty: [],
  OpenapiPostV1TreasuryOutboundPaymentsInput: [
    'destination_payment_method_data.billing_details.address',
    'destination_payment_method_options.us_bank_account',
  ],
  OpenapiPostV1TreasuryOutboundPaymentsInputDestinationPaymentMethodData: [
    'billing_details.address',
  ],
  OpenapiPostV1TreasuryOutboundPaymentsInputDestinationPaymentMethodDataBillingDetails: [
    'address',
  ],
  OpenapiPostV1TreasuryOutboundPaymentsInputDestinationPaymentMethodDataBillingDetailsAddressMaybeEmpty: [],
  OpenapiPostV1TreasuryOutboundPaymentsInputDestinationPaymentMethodOptions: [
    'us_bank_account',
  ],
  OpenapiPostV1TreasuryOutboundPaymentsInputDestinationPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiPostV1TreasuryOutboundTransfersInput: [
    'destination_payment_method_options.us_bank_account',
  ],
  OpenapiPostV1TreasuryOutboundTransfersInputDestinationPaymentMethodOptions: [
    'us_bank_account',
  ],
  OpenapiPostV1TreasuryOutboundTransfersInputDestinationPaymentMethodOptionsUsBankAccountMaybeEmpty: [],
  OpenapiPostV1WebhookEndpointsInput: [
    'metadata',
  ],
  OpenapiPostV1WebhookEndpointsInputMetadataMaybeEmpty: [],
  OpenapiPostV1WebhookEndpointsWebhookEndpointInput: [
    'metadata',
  ],
  OpenapiPostV1WebhookEndpointsWebhookEndpointInputMetadataMaybeEmpty: [],
} as const;

export type unused = unknown;
